/**
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { _ as _objectWithoutProperties, I as Icon, a as _extends } from '../Icon-882b0ed1.js';
import React from 'react';
import '@carbon/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _circle, _path21, _path22, _circle2, _path23, _path24, _circle3, _path25, _path26, _circle4, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _circle5, _path53, _circle6, _path54, _circle7, _path55, _circle8, _path56, _circle9, _path57, _circle10, _path58, _path59, _circle11, _path60, _circle12, _path61, _path62, _circle13, _path63, _circle14, _path64, _path65, _circle15, _path66, _circle16, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _circle17, _path247, _path248, _path249, _circle18, _path250, _path251, _path252, _circle19, _path253, _path254, _path255, _circle20, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _circle21, _path297, _path298, _circle22, _path299, _path300, _circle23, _path301, _path302, _circle24, _path303, _path304, _path305, _path306, _path307, _path308, _circle25, _path309, _path310, _path311, _circle26, _path312, _path313, _path314, _circle27, _path315, _path316, _path317, _circle28, _path318, _path319, _path320, _circle29, _path321, _circle30, _path322, _circle31, _path323, _circle32, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516;
var ViewNext32 = /*#__PURE__*/React.forwardRef(function ViewNext32(_ref, ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.587 22L15 16.41 15 7 16.998 7 16.998 15.582 22 20.587 20.587 22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z"
  })), children);
});
var ViewNext24 = /*#__PURE__*/React.forwardRef(function ViewNext24(_ref2, ref) {
  var children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.587 22L15 16.41 15 7 16.998 7 16.998 15.582 22 20.587 20.587 22z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z"
  })), children);
});
var ViewNext20 = /*#__PURE__*/React.forwardRef(function ViewNext20(_ref3, ref) {
  var children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.587 22L15 16.41 15 7 16.998 7 16.998 15.582 22 20.587 20.587 22z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z"
  })), children);
});
var ViewNext16 = /*#__PURE__*/React.forwardRef(function ViewNext16(_ref4, ref) {
  var children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.587 22L15 16.41 15 7 16.998 7 16.998 15.582 22 20.587 20.587 22z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z"
  })), children);
});
var VirtualColumn32 = /*#__PURE__*/React.forwardRef(function VirtualColumn32(_ref5, ref) {
  var children = _ref5.children,
      rest = _objectWithoutProperties(_ref5, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11L26.414 12.414 23.828 15 30 15 30 17 23.828 17 26.414 19.586 25 21 20 16 25 11z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30 28H20a2.0023 2.0023 0 01-2-2V6a2.0023 2.0023 0 012-2H30V6H20V26H30zM12 28H2V26H12V6H2V4H12a2.0023 2.0023 0 012 2V26A2.0023 2.0023 0 0112 28z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11L5.586 12.414 8.172 15 2 15 2 17 8.172 17 5.586 19.586 7 21 12 16 7 11z"
  })), children);
});
var VirtualColumn24 = /*#__PURE__*/React.forwardRef(function VirtualColumn24(_ref6, ref) {
  var children = _ref6.children,
      rest = _objectWithoutProperties(_ref6, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11L26.414 12.414 23.828 15 30 15 30 17 23.828 17 26.414 19.586 25 21 20 16 25 11z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30 28H20a2.0023 2.0023 0 01-2-2V6a2.0023 2.0023 0 012-2H30V6H20V26H30zM12 28H2V26H12V6H2V4H12a2.0023 2.0023 0 012 2V26A2.0023 2.0023 0 0112 28z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11L5.586 12.414 8.172 15 2 15 2 17 8.172 17 5.586 19.586 7 21 12 16 7 11z"
  })), children);
});
var VirtualColumn20 = /*#__PURE__*/React.forwardRef(function VirtualColumn20(_ref7, ref) {
  var children = _ref7.children,
      rest = _objectWithoutProperties(_ref7, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11L26.414 12.414 23.828 15 30 15 30 17 23.828 17 26.414 19.586 25 21 20 16 25 11z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30 28H20a2.0023 2.0023 0 01-2-2V6a2.0023 2.0023 0 012-2H30V6H20V26H30zM12 28H2V26H12V6H2V4H12a2.0023 2.0023 0 012 2V26A2.0023 2.0023 0 0112 28z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11L5.586 12.414 8.172 15 2 15 2 17 8.172 17 5.586 19.586 7 21 12 16 7 11z"
  })), children);
});
var VirtualColumn16 = /*#__PURE__*/React.forwardRef(function VirtualColumn16(_ref8, ref) {
  var children = _ref8.children,
      rest = _objectWithoutProperties(_ref8, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11L26.414 12.414 23.828 15 30 15 30 17 23.828 17 26.414 19.586 25 21 20 16 25 11z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30 28H20a2.0023 2.0023 0 01-2-2V6a2.0023 2.0023 0 012-2H30V6H20V26H30zM12 28H2V26H12V6H2V4H12a2.0023 2.0023 0 012 2V26A2.0023 2.0023 0 0112 28z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11L5.586 12.414 8.172 15 2 15 2 17 8.172 17 5.586 19.586 7 21 12 16 7 11z"
  })), children);
});
var VirtualColumnKey32 = /*#__PURE__*/React.forwardRef(function VirtualColumnKey32(_ref9, ref) {
  var children = _ref9.children,
      rest = _objectWithoutProperties(_ref9, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "24.5",
    cy: "9.5",
    r: "1.5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4143,22H12V16.5857l6.03-6.03A5.3518,5.3518,0,0,1,18,10a6,6,0,1,1,6,6,5.3583,5.3583,0,0,1-.5559-.03ZM14,20h2.5857l6.1706-6.1709.5174.0957A3.935,3.935,0,0,0,24,14a4.0507,4.0507,0,1,0-3.925-3.2729l.0952.5166L14,17.4143Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M28,18v8H10V6h4V4H4A2.0025,2.0025,0,0,0,2,6V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V18ZM4,6H8V26H4Z"
  })), children);
});
var VirtualColumnKey24 = /*#__PURE__*/React.forwardRef(function VirtualColumnKey24(_ref10, ref) {
  var children = _ref10.children,
      rest = _objectWithoutProperties(_ref10, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.5",
    cy: "9.5",
    r: "1.5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4143,22H12V16.5857l6.03-6.03A5.3518,5.3518,0,0,1,18,10a6,6,0,1,1,6,6,5.3583,5.3583,0,0,1-.5559-.03ZM14,20h2.5857l6.1706-6.1709.5174.0957A3.935,3.935,0,0,0,24,14a4.0507,4.0507,0,1,0-3.925-3.2729l.0952.5166L14,17.4143Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28,18v8H10V6h4V4H4A2.0025,2.0025,0,0,0,2,6V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V18ZM4,6H8V26H4Z"
  })), children);
});
var VirtualColumnKey20 = /*#__PURE__*/React.forwardRef(function VirtualColumnKey20(_ref11, ref) {
  var children = _ref11.children,
      rest = _objectWithoutProperties(_ref11, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.5",
    cy: "9.5",
    r: "1.5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4143,22H12V16.5857l6.03-6.03A5.3518,5.3518,0,0,1,18,10a6,6,0,1,1,6,6,5.3583,5.3583,0,0,1-.5559-.03ZM14,20h2.5857l6.1706-6.1709.5174.0957A3.935,3.935,0,0,0,24,14a4.0507,4.0507,0,1,0-3.925-3.2729l.0952.5166L14,17.4143Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28,18v8H10V6h4V4H4A2.0025,2.0025,0,0,0,2,6V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V18ZM4,6H8V26H4Z"
  })), children);
});
var VirtualColumnKey16 = /*#__PURE__*/React.forwardRef(function VirtualColumnKey16(_ref12, ref) {
  var children = _ref12.children,
      rest = _objectWithoutProperties(_ref12, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.5",
    cy: "9.5",
    r: "1.5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4143,22H12V16.5857l6.03-6.03A5.3518,5.3518,0,0,1,18,10a6,6,0,1,1,6,6,5.3583,5.3583,0,0,1-.5559-.03ZM14,20h2.5857l6.1706-6.1709.5174.0957A3.935,3.935,0,0,0,24,14a4.0507,4.0507,0,1,0-3.925-3.2729l.0952.5166L14,17.4143Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28,18v8H10V6h4V4H4A2.0025,2.0025,0,0,0,2,6V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V18ZM4,6H8V26H4Z"
  })), children);
});
var VirtualMachine32 = /*#__PURE__*/React.forwardRef(function VirtualMachine32(_ref13, ref) {
  var children = _ref13.children,
      rest = _objectWithoutProperties(_ref13, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13H12a2.0025,2.0025,0,0,0-2,2V28a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V15A2.0025,2.0025,0,0,0,20,13Zm0,2,0,3H12V15Zm0,5,0,3H12V20Zm-8,8V25h8v3Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M25.91,10.13a.121.121,0,0,1-.0967-.0952A10.0061,10.0061,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.1858,10.0347a.1212.1212,0,0,1-.0964.0957A7.5019,7.5019,0,0,0,7.4912,25H8V23H7.4954a5.5108,5.5108,0,0,1-5.4387-6.3,5.6992,5.6992,0,0,1,4.7138-4.6606l1.0166-.1836a.1306.1306,0,0,0,.1045-.1035l.18-.9351a8.28,8.28,0,0,1,6.8469-6.7427,7.957,7.957,0,0,1,2.8471.1245,8.22,8.22,0,0,1,6.1475,6.545l.1941,1.0083a.13.13,0,0,0,.1045.1035l1.0576.1914a5.7819,5.7819,0,0,1,3.1011,1.539A5.5052,5.5052,0,0,1,24.5076,23H24v2h.5076A7.5019,7.5019,0,0,0,25.91,10.13Z"
  })), children);
});
var VirtualMachine24 = /*#__PURE__*/React.forwardRef(function VirtualMachine24(_ref14, ref) {
  var children = _ref14.children,
      rest = _objectWithoutProperties(_ref14, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13H12a2.0025,2.0025,0,0,0-2,2V28a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V15A2.0025,2.0025,0,0,0,20,13Zm0,2,0,3H12V15Zm0,5,0,3H12V20Zm-8,8V25h8v3Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M25.91,10.13a.121.121,0,0,1-.0967-.0952A10.0061,10.0061,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.1858,10.0347a.1212.1212,0,0,1-.0964.0957A7.5019,7.5019,0,0,0,7.4912,25H8V23H7.4954a5.5108,5.5108,0,0,1-5.4387-6.3,5.6992,5.6992,0,0,1,4.7138-4.6606l1.0166-.1836a.1306.1306,0,0,0,.1045-.1035l.18-.9351a8.28,8.28,0,0,1,6.8469-6.7427,7.957,7.957,0,0,1,2.8471.1245,8.22,8.22,0,0,1,6.1475,6.545l.1941,1.0083a.13.13,0,0,0,.1045.1035l1.0576.1914a5.7819,5.7819,0,0,1,3.1011,1.539A5.5052,5.5052,0,0,1,24.5076,23H24v2h.5076A7.5019,7.5019,0,0,0,25.91,10.13Z"
  })), children);
});
var VirtualMachine20 = /*#__PURE__*/React.forwardRef(function VirtualMachine20(_ref15, ref) {
  var children = _ref15.children,
      rest = _objectWithoutProperties(_ref15, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13H12a2.0025,2.0025,0,0,0-2,2V28a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V15A2.0025,2.0025,0,0,0,20,13Zm0,2,0,3H12V15Zm0,5,0,3H12V20Zm-8,8V25h8v3Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M25.91,10.13a.121.121,0,0,1-.0967-.0952A10.0061,10.0061,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.1858,10.0347a.1212.1212,0,0,1-.0964.0957A7.5019,7.5019,0,0,0,7.4912,25H8V23H7.4954a5.5108,5.5108,0,0,1-5.4387-6.3,5.6992,5.6992,0,0,1,4.7138-4.6606l1.0166-.1836a.1306.1306,0,0,0,.1045-.1035l.18-.9351a8.28,8.28,0,0,1,6.8469-6.7427,7.957,7.957,0,0,1,2.8471.1245,8.22,8.22,0,0,1,6.1475,6.545l.1941,1.0083a.13.13,0,0,0,.1045.1035l1.0576.1914a5.7819,5.7819,0,0,1,3.1011,1.539A5.5052,5.5052,0,0,1,24.5076,23H24v2h.5076A7.5019,7.5019,0,0,0,25.91,10.13Z"
  })), children);
});
var VirtualMachine16 = /*#__PURE__*/React.forwardRef(function VirtualMachine16(_ref16, ref) {
  var children = _ref16.children,
      rest = _objectWithoutProperties(_ref16, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13H12a2.0025,2.0025,0,0,0-2,2V28a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V15A2.0025,2.0025,0,0,0,20,13Zm0,2,0,3H12V15Zm0,5,0,3H12V20Zm-8,8V25h8v3Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M25.91,10.13a.121.121,0,0,1-.0967-.0952A10.0061,10.0061,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.1858,10.0347a.1212.1212,0,0,1-.0964.0957A7.5019,7.5019,0,0,0,7.4912,25H8V23H7.4954a5.5108,5.5108,0,0,1-5.4387-6.3,5.6992,5.6992,0,0,1,4.7138-4.6606l1.0166-.1836a.1306.1306,0,0,0,.1045-.1035l.18-.9351a8.28,8.28,0,0,1,6.8469-6.7427,7.957,7.957,0,0,1,2.8471.1245,8.22,8.22,0,0,1,6.1475,6.545l.1941,1.0083a.13.13,0,0,0,.1045.1035l1.0576.1914a5.7819,5.7819,0,0,1,3.1011,1.539A5.5052,5.5052,0,0,1,24.5076,23H24v2h.5076A7.5019,7.5019,0,0,0,25.91,10.13Z"
  })), children);
});
var VirtualPrivateCloud32 = /*#__PURE__*/React.forwardRef(function VirtualPrivateCloud32(_ref17, ref) {
  var children = _ref17.children,
      rest = _objectWithoutProperties(_ref17, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20V17a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v6a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V22A2.0025,2.0025,0,0,0,20,20Zm-6-3a2,2,0,0,1,4,0v3H14ZM12,28V22h8l.0012,6Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8288,10.1152A10.0067,10.0067,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.17,10.1152,7.502,7.502,0,0,0,7.4912,25H8V23H7.4953a5.5019,5.5019,0,0,1-.9694-10.9165l1.3488-.2441.2591-1.3457a8.0109,8.0109,0,0,1,15.7312,0l.259,1.3457,1.3489.2441A5.5019,5.5019,0,0,1,24.5076,23H24v2h.5076a7.502,7.502,0,0,0,1.3212-14.8848Z"
  })), children);
});
var VirtualPrivateCloud24 = /*#__PURE__*/React.forwardRef(function VirtualPrivateCloud24(_ref18, ref) {
  var children = _ref18.children,
      rest = _objectWithoutProperties(_ref18, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20V17a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v6a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V22A2.0025,2.0025,0,0,0,20,20Zm-6-3a2,2,0,0,1,4,0v3H14ZM12,28V22h8l.0012,6Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8288,10.1152A10.0067,10.0067,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.17,10.1152,7.502,7.502,0,0,0,7.4912,25H8V23H7.4953a5.5019,5.5019,0,0,1-.9694-10.9165l1.3488-.2441.2591-1.3457a8.0109,8.0109,0,0,1,15.7312,0l.259,1.3457,1.3489.2441A5.5019,5.5019,0,0,1,24.5076,23H24v2h.5076a7.502,7.502,0,0,0,1.3212-14.8848Z"
  })), children);
});
var VirtualPrivateCloud20 = /*#__PURE__*/React.forwardRef(function VirtualPrivateCloud20(_ref19, ref) {
  var children = _ref19.children,
      rest = _objectWithoutProperties(_ref19, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20V17a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v6a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V22A2.0025,2.0025,0,0,0,20,20Zm-6-3a2,2,0,0,1,4,0v3H14ZM12,28V22h8l.0012,6Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8288,10.1152A10.0067,10.0067,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.17,10.1152,7.502,7.502,0,0,0,7.4912,25H8V23H7.4953a5.5019,5.5019,0,0,1-.9694-10.9165l1.3488-.2441.2591-1.3457a8.0109,8.0109,0,0,1,15.7312,0l.259,1.3457,1.3489.2441A5.5019,5.5019,0,0,1,24.5076,23H24v2h.5076a7.502,7.502,0,0,0,1.3212-14.8848Z"
  })), children);
});
var VirtualPrivateCloud16 = /*#__PURE__*/React.forwardRef(function VirtualPrivateCloud16(_ref20, ref) {
  var children = _ref20.children,
      rest = _objectWithoutProperties(_ref20, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20V17a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v6a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V22A2.0025,2.0025,0,0,0,20,20Zm-6-3a2,2,0,0,1,4,0v3H14ZM12,28V22h8l.0012,6Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8288,10.1152A10.0067,10.0067,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.17,10.1152,7.502,7.502,0,0,0,7.4912,25H8V23H7.4953a5.5019,5.5019,0,0,1-.9694-10.9165l1.3488-.2441.2591-1.3457a8.0109,8.0109,0,0,1,15.7312,0l.259,1.3457,1.3489.2441A5.5019,5.5019,0,0,1,24.5076,23H24v2h.5076a7.502,7.502,0,0,0,1.3212-14.8848Z"
  })), children);
});
var VirtualPrivateCloudAlt32 = /*#__PURE__*/React.forwardRef(function VirtualPrivateCloudAlt32(_ref21, ref) {
  var children = _ref21.children,
      rest = _objectWithoutProperties(_ref21, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4141,22,10,8.5859V2H2v8H8.5859L22,23.4141V30h8V22ZM8,8H4V4H8ZM28,28H24V24h4Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6a3.9915 3.9915 0 00-7.8579-1H13V7h9.1421A3.9945 3.9945 0 0025 9.8579V19h2V9.8579A3.9962 3.9962 0 0030 6zM26 8a2 2 0 112-2A2.0023 2.0023 0 0126 8zM19 25H9.8579A3.9945 3.9945 0 007 22.1421V13H5v9.1421A3.9915 3.9915 0 109.8579 27H19zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
  })), children);
});
var VirtualPrivateCloudAlt24 = /*#__PURE__*/React.forwardRef(function VirtualPrivateCloudAlt24(_ref22, ref) {
  var children = _ref22.children,
      rest = _objectWithoutProperties(_ref22, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4141,22,10,8.5859V2H2v8H8.5859L22,23.4141V30h8V22ZM8,8H4V4H8ZM28,28H24V24h4Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6a3.9915 3.9915 0 00-7.8579-1H13V7h9.1421A3.9945 3.9945 0 0025 9.8579V19h2V9.8579A3.9962 3.9962 0 0030 6zM26 8a2 2 0 112-2A2.0023 2.0023 0 0126 8zM19 25H9.8579A3.9945 3.9945 0 007 22.1421V13H5v9.1421A3.9915 3.9915 0 109.8579 27H19zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
  })), children);
});
var VirtualPrivateCloudAlt20 = /*#__PURE__*/React.forwardRef(function VirtualPrivateCloudAlt20(_ref23, ref) {
  var children = _ref23.children,
      rest = _objectWithoutProperties(_ref23, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4141,22,10,8.5859V2H2v8H8.5859L22,23.4141V30h8V22ZM8,8H4V4H8ZM28,28H24V24h4Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6a3.9915 3.9915 0 00-7.8579-1H13V7h9.1421A3.9945 3.9945 0 0025 9.8579V19h2V9.8579A3.9962 3.9962 0 0030 6zM26 8a2 2 0 112-2A2.0023 2.0023 0 0126 8zM19 25H9.8579A3.9945 3.9945 0 007 22.1421V13H5v9.1421A3.9915 3.9915 0 109.8579 27H19zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
  })), children);
});
var VirtualPrivateCloudAlt16 = /*#__PURE__*/React.forwardRef(function VirtualPrivateCloudAlt16(_ref24, ref) {
  var children = _ref24.children,
      rest = _objectWithoutProperties(_ref24, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4141,22,10,8.5859V2H2v8H8.5859L22,23.4141V30h8V22ZM8,8H4V4H8ZM28,28H24V24h4Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6a3.9915 3.9915 0 00-7.8579-1H13V7h9.1421A3.9945 3.9945 0 0025 9.8579V19h2V9.8579A3.9962 3.9962 0 0030 6zM26 8a2 2 0 112-2A2.0023 2.0023 0 0126 8zM19 25H9.8579A3.9945 3.9945 0 007 22.1421V13H5v9.1421A3.9915 3.9915 0 109.8579 27H19zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
  })), children);
});
var VisualRecognition32 = /*#__PURE__*/React.forwardRef(function VisualRecognition32(_ref25, ref) {
  var children = _ref25.children,
      rest = _objectWithoutProperties(_ref25, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "2"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M28,5H16.24A8,8,0,1,0,6,16.92V27a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V7A2,2,0,0,0,28,5ZM4,10A6,6,0,0,1,15.19,7H8V9h7.91A6.64,6.64,0,0,1,16,10a6.64,6.64,0,0,1-.09,1H10v2h5.19A6,6,0,0,1,4,10ZM28,27H8l5-5,1.59,1.59a2,2,0,0,0,2.82,0L23,18l5,5Zm0-6.83-3.59-3.59a2,2,0,0,0-2.82,0L16,22.17l-1.59-1.59a2,2,0,0,0-2.82,0L8,24.17V17.74A8.24,8.24,0,0,0,10,18a8,8,0,0,0,8-8,7.9,7.9,0,0,0-.59-3H28Z"
  })), children);
});
var VisualRecognition24 = /*#__PURE__*/React.forwardRef(function VisualRecognition24(_ref26, ref) {
  var children = _ref26.children,
      rest = _objectWithoutProperties(_ref26, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "2"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M28,5H16.24A8,8,0,1,0,6,16.92V27a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V7A2,2,0,0,0,28,5ZM4,10A6,6,0,0,1,15.19,7H8V9h7.91A6.64,6.64,0,0,1,16,10a6.64,6.64,0,0,1-.09,1H10v2h5.19A6,6,0,0,1,4,10ZM28,27H8l5-5,1.59,1.59a2,2,0,0,0,2.82,0L23,18l5,5Zm0-6.83-3.59-3.59a2,2,0,0,0-2.82,0L16,22.17l-1.59-1.59a2,2,0,0,0-2.82,0L8,24.17V17.74A8.24,8.24,0,0,0,10,18a8,8,0,0,0,8-8,7.9,7.9,0,0,0-.59-3H28Z"
  })), children);
});
var VisualRecognition20 = /*#__PURE__*/React.forwardRef(function VisualRecognition20(_ref27, ref) {
  var children = _ref27.children,
      rest = _objectWithoutProperties(_ref27, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "2"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M28,5H16.24A8,8,0,1,0,6,16.92V27a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V7A2,2,0,0,0,28,5ZM4,10A6,6,0,0,1,15.19,7H8V9h7.91A6.64,6.64,0,0,1,16,10a6.64,6.64,0,0,1-.09,1H10v2h5.19A6,6,0,0,1,4,10ZM28,27H8l5-5,1.59,1.59a2,2,0,0,0,2.82,0L23,18l5,5Zm0-6.83-3.59-3.59a2,2,0,0,0-2.82,0L16,22.17l-1.59-1.59a2,2,0,0,0-2.82,0L8,24.17V17.74A8.24,8.24,0,0,0,10,18a8,8,0,0,0,8-8,7.9,7.9,0,0,0-.59-3H28Z"
  })), children);
});
var VisualRecognition16 = /*#__PURE__*/React.forwardRef(function VisualRecognition16(_ref28, ref) {
  var children = _ref28.children,
      rest = _objectWithoutProperties(_ref28, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "2"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M28,5H16.24A8,8,0,1,0,6,16.92V27a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V7A2,2,0,0,0,28,5ZM4,10A6,6,0,0,1,15.19,7H8V9h7.91A6.64,6.64,0,0,1,16,10a6.64,6.64,0,0,1-.09,1H10v2h5.19A6,6,0,0,1,4,10ZM28,27H8l5-5,1.59,1.59a2,2,0,0,0,2.82,0L23,18l5,5Zm0-6.83-3.59-3.59a2,2,0,0,0-2.82,0L16,22.17l-1.59-1.59a2,2,0,0,0-2.82,0L8,24.17V17.74A8.24,8.24,0,0,0,10,18a8,8,0,0,0,8-8,7.9,7.9,0,0,0-.59-3H28Z"
  })), children);
});
var VmdkDisk32 = /*#__PURE__*/React.forwardRef(function VmdkDisk32(_ref29, ref) {
  var children = _ref29.children,
      rest = _objectWithoutProperties(_ref29, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "10.5",
    cy: "24.5",
    r: "1.5"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14.964H21.5V20.035H19.5z",
    transform: "rotate(-45 20.5 17.5)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "13",
    r: "2"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6a7,7,0,0,0,0,14V18a5,5,0,1,1,5-5h2A7,7,0,0,0,16,6Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H6V4H26Z"
  })), children);
});
var VmdkDisk24 = /*#__PURE__*/React.forwardRef(function VmdkDisk24(_ref30, ref) {
  var children = _ref30.children,
      rest = _objectWithoutProperties(_ref30, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "10.5",
    cy: "24.5",
    r: "1.5"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14.964H21.5V20.035H19.5z",
    transform: "rotate(-45 20.5 17.5)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "13",
    r: "2"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6a7,7,0,0,0,0,14V18a5,5,0,1,1,5-5h2A7,7,0,0,0,16,6Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H6V4H26Z"
  })), children);
});
var VmdkDisk20 = /*#__PURE__*/React.forwardRef(function VmdkDisk20(_ref31, ref) {
  var children = _ref31.children,
      rest = _objectWithoutProperties(_ref31, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "10.5",
    cy: "24.5",
    r: "1.5"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14.964H21.5V20.035H19.5z",
    transform: "rotate(-45 20.5 17.5)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "13",
    r: "2"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6a7,7,0,0,0,0,14V18a5,5,0,1,1,5-5h2A7,7,0,0,0,16,6Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H6V4H26Z"
  })), children);
});
var VmdkDisk16 = /*#__PURE__*/React.forwardRef(function VmdkDisk16(_ref32, ref) {
  var children = _ref32.children,
      rest = _objectWithoutProperties(_ref32, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "10.5",
    cy: "24.5",
    r: "1.5"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14.964H21.5V20.035H19.5z",
    transform: "rotate(-45 20.5 17.5)"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "13",
    r: "2"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6a7,7,0,0,0,0,14V18a5,5,0,1,1,5-5h2A7,7,0,0,0,16,6Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H6V4H26Z"
  })), children);
});
var VoiceActivate32 = /*#__PURE__*/React.forwardRef(function VoiceActivate32(_ref33, ref) {
  var children = _ref33.children,
      rest = _objectWithoutProperties(_ref33, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12H23V14H19zM9.3325 25.2168a7.0007 7.0007 0 010-10.4341l1.334 1.49a5 5 0 000 7.4537z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3994,28.8008a11.0019,11.0019,0,0,1,0-17.6006L7.6,12.8a9.0009,9.0009,0,0,0,0,14.4014Z"
  })), children);
});
var VoiceActivate24 = /*#__PURE__*/React.forwardRef(function VoiceActivate24(_ref34, ref) {
  var children = _ref34.children,
      rest = _objectWithoutProperties(_ref34, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12H23V14H19zM9.3325 25.2168a7.0007 7.0007 0 010-10.4341l1.334 1.49a5 5 0 000 7.4537z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3994,28.8008a11.0019,11.0019,0,0,1,0-17.6006L7.6,12.8a9.0009,9.0009,0,0,0,0,14.4014Z"
  })), children);
});
var VoiceActivate20 = /*#__PURE__*/React.forwardRef(function VoiceActivate20(_ref35, ref) {
  var children = _ref35.children,
      rest = _objectWithoutProperties(_ref35, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12H23V14H19zM9.3325 25.2168a7.0007 7.0007 0 010-10.4341l1.334 1.49a5 5 0 000 7.4537z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3994,28.8008a11.0019,11.0019,0,0,1,0-17.6006L7.6,12.8a9.0009,9.0009,0,0,0,0,14.4014Z"
  })), children);
});
var VoiceActivate16 = /*#__PURE__*/React.forwardRef(function VoiceActivate16(_ref36, ref) {
  var children = _ref36.children,
      rest = _objectWithoutProperties(_ref36, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12H23V14H19zM9.3325 25.2168a7.0007 7.0007 0 010-10.4341l1.334 1.49a5 5 0 000 7.4537z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3994,28.8008a11.0019,11.0019,0,0,1,0-17.6006L7.6,12.8a9.0009,9.0009,0,0,0,0,14.4014Z"
  })), children);
});
var Voicemail32 = /*#__PURE__*/React.forwardRef(function Voicemail32(_ref37, ref) {
  var children = _ref37.children,
      rest = _objectWithoutProperties(_ref37, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M24,10a6,6,0,0,0-4.46,10H12.46A6,6,0,1,0,8,22H24a6,6,0,0,0,0-12ZM4,16a4,4,0,1,1,4,4A4,4,0,0,1,4,16Zm20,4a4,4,0,1,1,4-4A4,4,0,0,1,24,20Z"
  })), children);
});
var Voicemail24 = /*#__PURE__*/React.forwardRef(function Voicemail24(_ref38, ref) {
  var children = _ref38.children,
      rest = _objectWithoutProperties(_ref38, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M24,10a6,6,0,0,0-4.46,10H12.46A6,6,0,1,0,8,22H24a6,6,0,0,0,0-12ZM4,16a4,4,0,1,1,4,4A4,4,0,0,1,4,16Zm20,4a4,4,0,1,1,4-4A4,4,0,0,1,24,20Z"
  })), children);
});
var Voicemail20 = /*#__PURE__*/React.forwardRef(function Voicemail20(_ref39, ref) {
  var children = _ref39.children,
      rest = _objectWithoutProperties(_ref39, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M24,10a6,6,0,0,0-4.46,10H12.46A6,6,0,1,0,8,22H24a6,6,0,0,0,0-12ZM4,16a4,4,0,1,1,4,4A4,4,0,0,1,4,16Zm20,4a4,4,0,1,1,4-4A4,4,0,0,1,24,20Z"
  })), children);
});
var Voicemail16 = /*#__PURE__*/React.forwardRef(function Voicemail16(_ref40, ref) {
  var children = _ref40.children,
      rest = _objectWithoutProperties(_ref40, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M24,10a6,6,0,0,0-4.46,10H12.46A6,6,0,1,0,8,22H24a6,6,0,0,0,0-12ZM4,16a4,4,0,1,1,4,4A4,4,0,0,1,4,16Zm20,4a4,4,0,1,1,4-4A4,4,0,0,1,24,20Z"
  })), children);
});
var VolumeDown32 = /*#__PURE__*/React.forwardRef(function VolumeDown32(_ref41, ref) {
  var children = _ref41.children,
      rest = _objectWithoutProperties(_ref41, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1 10.66L23.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM20 30a1 1 0 01-.71-.3L11.67 22H5a1 1 0 01-1-1H4V11a1 1 0 011-1h6.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0121 3V29A1 1 0 0120 30zM6 20h6a1.17 1.17 0 01.79.3L19 26.57V5.43L12.79 11.7A1.17 1.17 0 0112 12H6z"
  })), children);
});
var VolumeDown24 = /*#__PURE__*/React.forwardRef(function VolumeDown24(_ref42, ref) {
  var children = _ref42.children,
      rest = _objectWithoutProperties(_ref42, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1 10.66L23.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM20 30a1 1 0 01-.71-.3L11.67 22H5a1 1 0 01-1-1H4V11a1 1 0 011-1h6.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0121 3V29A1 1 0 0120 30zM6 20h6a1.17 1.17 0 01.79.3L19 26.57V5.43L12.79 11.7A1.17 1.17 0 0112 12H6z"
  })), children);
});
var VolumeDown20 = /*#__PURE__*/React.forwardRef(function VolumeDown20(_ref43, ref) {
  var children = _ref43.children,
      rest = _objectWithoutProperties(_ref43, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1 10.66L23.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM20 30a1 1 0 01-.71-.3L11.67 22H5a1 1 0 01-1-1H4V11a1 1 0 011-1h6.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0121 3V29A1 1 0 0120 30zM6 20h6a1.17 1.17 0 01.79.3L19 26.57V5.43L12.79 11.7A1.17 1.17 0 0112 12H6z"
  })), children);
});
var VolumeDown16 = /*#__PURE__*/React.forwardRef(function VolumeDown16(_ref44, ref) {
  var children = _ref44.children,
      rest = _objectWithoutProperties(_ref44, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1 10.66L23.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM20 30a1 1 0 01-.71-.3L11.67 22H5a1 1 0 01-1-1H4V11a1 1 0 011-1h6.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0121 3V29A1 1 0 0120 30zM6 20h6a1.17 1.17 0 01.79.3L19 26.57V5.43L12.79 11.7A1.17 1.17 0 0112 12H6z"
  })), children);
});
var VolumeDownAlt32 = /*#__PURE__*/React.forwardRef(function VolumeDownAlt32(_ref45, ref) {
  var children = _ref45.children,
      rest = _objectWithoutProperties(_ref45, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15H32V17H22zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30zM4 20h6a1.2008 1.2008 0 01.7939.2969L17 26.5684V5.4316l-6.2061 6.2715A1.2013 1.2013 0 0110 12H4z"
  })), children);
});
var VolumeDownAlt24 = /*#__PURE__*/React.forwardRef(function VolumeDownAlt24(_ref46, ref) {
  var children = _ref46.children,
      rest = _objectWithoutProperties(_ref46, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15H32V17H22zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30zM4 20h6a1.2008 1.2008 0 01.7939.2969L17 26.5684V5.4316l-6.2061 6.2715A1.2013 1.2013 0 0110 12H4z"
  })), children);
});
var VolumeDownAlt20 = /*#__PURE__*/React.forwardRef(function VolumeDownAlt20(_ref47, ref) {
  var children = _ref47.children,
      rest = _objectWithoutProperties(_ref47, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15H32V17H22zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30zM4 20h6a1.2008 1.2008 0 01.7939.2969L17 26.5684V5.4316l-6.2061 6.2715A1.2013 1.2013 0 0110 12H4z"
  })), children);
});
var VolumeDownAlt16 = /*#__PURE__*/React.forwardRef(function VolumeDownAlt16(_ref48, ref) {
  var children = _ref48.children,
      rest = _objectWithoutProperties(_ref48, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15H32V17H22zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30zM4 20h6a1.2008 1.2008 0 01.7939.2969L17 26.5684V5.4316l-6.2061 6.2715A1.2013 1.2013 0 0110 12H4z"
  })), children);
});
var VolumeDownFilled32 = /*#__PURE__*/React.forwardRef(function VolumeDownFilled32(_ref49, ref) {
  var children = _ref49.children,
      rest = _objectWithoutProperties(_ref49, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1 10.66L23.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM20 30a1 1 0 01-.71-.3L11.67 22H5a1 1 0 01-1-1H4V11a1 1 0 011-1h6.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0121 3V29A1 1 0 0120 30z"
  })), children);
});
var VolumeDownFilled24 = /*#__PURE__*/React.forwardRef(function VolumeDownFilled24(_ref50, ref) {
  var children = _ref50.children,
      rest = _objectWithoutProperties(_ref50, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1 10.66L23.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM20 30a1 1 0 01-.71-.3L11.67 22H5a1 1 0 01-1-1H4V11a1 1 0 011-1h6.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0121 3V29A1 1 0 0120 30z"
  })), children);
});
var VolumeDownFilled20 = /*#__PURE__*/React.forwardRef(function VolumeDownFilled20(_ref51, ref) {
  var children = _ref51.children,
      rest = _objectWithoutProperties(_ref51, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1 10.66L23.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM20 30a1 1 0 01-.71-.3L11.67 22H5a1 1 0 01-1-1H4V11a1 1 0 011-1h6.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0121 3V29A1 1 0 0120 30z"
  })), children);
});
var VolumeDownFilled16 = /*#__PURE__*/React.forwardRef(function VolumeDownFilled16(_ref52, ref) {
  var children = _ref52.children,
      rest = _objectWithoutProperties(_ref52, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1 10.66L23.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM20 30a1 1 0 01-.71-.3L11.67 22H5a1 1 0 01-1-1H4V11a1 1 0 011-1h6.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0121 3V29A1 1 0 0120 30z"
  })), children);
});
var VolumeDownFilledAlt32 = /*#__PURE__*/React.forwardRef(function VolumeDownFilledAlt32(_ref53, ref) {
  var children = _ref53.children,
      rest = _objectWithoutProperties(_ref53, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15H32V17H22zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30z"
  })), children);
});
var VolumeDownFilledAlt24 = /*#__PURE__*/React.forwardRef(function VolumeDownFilledAlt24(_ref54, ref) {
  var children = _ref54.children,
      rest = _objectWithoutProperties(_ref54, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15H32V17H22zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30z"
  })), children);
});
var VolumeDownFilledAlt20 = /*#__PURE__*/React.forwardRef(function VolumeDownFilledAlt20(_ref55, ref) {
  var children = _ref55.children,
      rest = _objectWithoutProperties(_ref55, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15H32V17H22zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30z"
  })), children);
});
var VolumeDownFilledAlt16 = /*#__PURE__*/React.forwardRef(function VolumeDownFilledAlt16(_ref56, ref) {
  var children = _ref56.children,
      rest = _objectWithoutProperties(_ref56, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15H32V17H22zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30z"
  })), children);
});
var VolumeMute32 = /*#__PURE__*/React.forwardRef(function VolumeMute32(_ref57, ref) {
  var children = _ref57.children,
      rest = _objectWithoutProperties(_ref57, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30zM4 20h6a1.17 1.17 0 01.79.3L17 26.57V5.43L10.79 11.7A1.17 1.17 0 0110 12H4z"
  })), children);
});
var VolumeMute24 = /*#__PURE__*/React.forwardRef(function VolumeMute24(_ref58, ref) {
  var children = _ref58.children,
      rest = _objectWithoutProperties(_ref58, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30zM4 20h6a1.17 1.17 0 01.79.3L17 26.57V5.43L10.79 11.7A1.17 1.17 0 0110 12H4z"
  })), children);
});
var VolumeMute20 = /*#__PURE__*/React.forwardRef(function VolumeMute20(_ref59, ref) {
  var children = _ref59.children,
      rest = _objectWithoutProperties(_ref59, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30zM4 20h6a1.17 1.17 0 01.79.3L17 26.57V5.43L10.79 11.7A1.17 1.17 0 0110 12H4z"
  })), children);
});
var VolumeMute16 = /*#__PURE__*/React.forwardRef(function VolumeMute16(_ref60, ref) {
  var children = _ref60.children,
      rest = _objectWithoutProperties(_ref60, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30zM4 20h6a1.17 1.17 0 01.79.3L17 26.57V5.43L10.79 11.7A1.17 1.17 0 0110 12H4z"
  })), children);
});
var VolumeMuteFilled32 = /*#__PURE__*/React.forwardRef(function VolumeMuteFilled32(_ref61, ref) {
  var children = _ref61.children,
      rest = _objectWithoutProperties(_ref61, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30z"
  })), children);
});
var VolumeMuteFilled24 = /*#__PURE__*/React.forwardRef(function VolumeMuteFilled24(_ref62, ref) {
  var children = _ref62.children,
      rest = _objectWithoutProperties(_ref62, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30z"
  })), children);
});
var VolumeMuteFilled20 = /*#__PURE__*/React.forwardRef(function VolumeMuteFilled20(_ref63, ref) {
  var children = _ref63.children,
      rest = _objectWithoutProperties(_ref63, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30z"
  })), children);
});
var VolumeMuteFilled16 = /*#__PURE__*/React.forwardRef(function VolumeMuteFilled16(_ref64, ref) {
  var children = _ref64.children,
      rest = _objectWithoutProperties(_ref64, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30z"
  })), children);
});
var VolumeUp32 = /*#__PURE__*/React.forwardRef(function VolumeUp32(_ref65, ref) {
  var children = _ref65.children,
      rest = _objectWithoutProperties(_ref65, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M21.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30zM4 20h6.08a1 1 0 01.71.3L17 26.57V5.43L10.79 11.7a1 1 0 01-.71.3H4z"
  })), children);
});
var VolumeUp24 = /*#__PURE__*/React.forwardRef(function VolumeUp24(_ref66, ref) {
  var children = _ref66.children,
      rest = _objectWithoutProperties(_ref66, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M21.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30zM4 20h6.08a1 1 0 01.71.3L17 26.57V5.43L10.79 11.7a1 1 0 01-.71.3H4z"
  })), children);
});
var VolumeUp20 = /*#__PURE__*/React.forwardRef(function VolumeUp20(_ref67, ref) {
  var children = _ref67.children,
      rest = _objectWithoutProperties(_ref67, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M21.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30zM4 20h6.08a1 1 0 01.71.3L17 26.57V5.43L10.79 11.7a1 1 0 01-.71.3H4z"
  })), children);
});
var VolumeUp16 = /*#__PURE__*/React.forwardRef(function VolumeUp16(_ref68, ref) {
  var children = _ref68.children,
      rest = _objectWithoutProperties(_ref68, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M21.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30zM4 20h6.08a1 1 0 01.71.3L17 26.57V5.43L10.79 11.7a1 1 0 01-.71.3H4z"
  })), children);
});
var VolumeUpAlt32 = /*#__PURE__*/React.forwardRef(function VolumeUpAlt32(_ref69, ref) {
  var children = _ref69.children,
      rest = _objectWithoutProperties(_ref69, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30zM4 20h6a1.2008 1.2008 0 01.7939.2969L17 26.5684V5.4316l-6.2061 6.2715A1.2013 1.2013 0 0110 12H4z"
  })), children);
});
var VolumeUpAlt24 = /*#__PURE__*/React.forwardRef(function VolumeUpAlt24(_ref70, ref) {
  var children = _ref70.children,
      rest = _objectWithoutProperties(_ref70, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30zM4 20h6a1.2008 1.2008 0 01.7939.2969L17 26.5684V5.4316l-6.2061 6.2715A1.2013 1.2013 0 0110 12H4z"
  })), children);
});
var VolumeUpAlt20 = /*#__PURE__*/React.forwardRef(function VolumeUpAlt20(_ref71, ref) {
  var children = _ref71.children,
      rest = _objectWithoutProperties(_ref71, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30zM4 20h6a1.2008 1.2008 0 01.7939.2969L17 26.5684V5.4316l-6.2061 6.2715A1.2013 1.2013 0 0110 12H4z"
  })), children);
});
var VolumeUpAlt16 = /*#__PURE__*/React.forwardRef(function VolumeUpAlt16(_ref72, ref) {
  var children = _ref72.children,
      rest = _objectWithoutProperties(_ref72, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30zM4 20h6a1.2008 1.2008 0 01.7939.2969L17 26.5684V5.4316l-6.2061 6.2715A1.2013 1.2013 0 0110 12H4z"
  })), children);
});
var VolumeUpFilled32 = /*#__PURE__*/React.forwardRef(function VolumeUpFilled32(_ref73, ref) {
  var children = _ref73.children,
      rest = _objectWithoutProperties(_ref73, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M21.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30z"
  })), children);
});
var VolumeUpFilled24 = /*#__PURE__*/React.forwardRef(function VolumeUpFilled24(_ref74, ref) {
  var children = _ref74.children,
      rest = _objectWithoutProperties(_ref74, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M21.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30z"
  })), children);
});
var VolumeUpFilled20 = /*#__PURE__*/React.forwardRef(function VolumeUpFilled20(_ref75, ref) {
  var children = _ref75.children,
      rest = _objectWithoutProperties(_ref75, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M21.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30z"
  })), children);
});
var VolumeUpFilled16 = /*#__PURE__*/React.forwardRef(function VolumeUpFilled16(_ref76, ref) {
  var children = _ref76.children,
      rest = _objectWithoutProperties(_ref76, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M21.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30z"
  })), children);
});
var VolumeUpFilledAlt32 = /*#__PURE__*/React.forwardRef(function VolumeUpFilledAlt32(_ref77, ref) {
  var children = _ref77.children,
      rest = _objectWithoutProperties(_ref77, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30z"
  })), children);
});
var VolumeUpFilledAlt24 = /*#__PURE__*/React.forwardRef(function VolumeUpFilledAlt24(_ref78, ref) {
  var children = _ref78.children,
      rest = _objectWithoutProperties(_ref78, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30z"
  })), children);
});
var VolumeUpFilledAlt20 = /*#__PURE__*/React.forwardRef(function VolumeUpFilledAlt20(_ref79, ref) {
  var children = _ref79.children,
      rest = _objectWithoutProperties(_ref79, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30z"
  })), children);
});
var VolumeUpFilledAlt16 = /*#__PURE__*/React.forwardRef(function VolumeUpFilledAlt16(_ref80, ref) {
  var children = _ref80.children,
      rest = _objectWithoutProperties(_ref80, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30z"
  })), children);
});
var Vpn32 = /*#__PURE__*/React.forwardRef(function Vpn32(_ref81, ref) {
  var children = _ref81.children,
      rest = _objectWithoutProperties(_ref81, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM28 19L24.32 9 22 9 22 23 24 23 24 13 27.68 23 30 23 30 9 28 9 28 19zM8 9L6 22 4 9 2 9 4.52 23 7.48 23 10 9 8 9z"
  })), children);
});
var Vpn24 = /*#__PURE__*/React.forwardRef(function Vpn24(_ref82, ref) {
  var children = _ref82.children,
      rest = _objectWithoutProperties(_ref82, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM28 19L24.32 9 22 9 22 23 24 23 24 13 27.68 23 30 23 30 9 28 9 28 19zM8 9L6 22 4 9 2 9 4.52 23 7.48 23 10 9 8 9z"
  })), children);
});
var Vpn20 = /*#__PURE__*/React.forwardRef(function Vpn20(_ref83, ref) {
  var children = _ref83.children,
      rest = _objectWithoutProperties(_ref83, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM28 19L24.32 9 22 9 22 23 24 23 24 13 27.68 23 30 23 30 9 28 9 28 19zM8 9L6 22 4 9 2 9 4.52 23 7.48 23 10 9 8 9z"
  })), children);
});
var Vpn16 = /*#__PURE__*/React.forwardRef(function Vpn16(_ref84, ref) {
  var children = _ref84.children,
      rest = _objectWithoutProperties(_ref84, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM28 19L24.32 9 22 9 22 23 24 23 24 13 27.68 23 30 23 30 9 28 9 28 19zM8 9L6 22 4 9 2 9 4.52 23 7.48 23 10 9 8 9z"
  })), children);
});
var Wallet32 = /*#__PURE__*/React.forwardRef(function Wallet32(_ref85, ref) {
  var children = _ref85.children,
      rest = _objectWithoutProperties(_ref85, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17H24V19H22z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H4V5H26V3H4A2,2,0,0,0,2,5V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM4,26V10H28v3H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h8v3ZM28,15v6H20V15Z"
  })), children);
});
var Wallet24 = /*#__PURE__*/React.forwardRef(function Wallet24(_ref86, ref) {
  var children = _ref86.children,
      rest = _objectWithoutProperties(_ref86, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17H24V19H22z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H4V5H26V3H4A2,2,0,0,0,2,5V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM4,26V10H28v3H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h8v3ZM28,15v6H20V15Z"
  })), children);
});
var Wallet20 = /*#__PURE__*/React.forwardRef(function Wallet20(_ref87, ref) {
  var children = _ref87.children,
      rest = _objectWithoutProperties(_ref87, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17H24V19H22z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H4V5H26V3H4A2,2,0,0,0,2,5V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM4,26V10H28v3H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h8v3ZM28,15v6H20V15Z"
  })), children);
});
var Wallet16 = /*#__PURE__*/React.forwardRef(function Wallet16(_ref88, ref) {
  var children = _ref88.children,
      rest = _objectWithoutProperties(_ref88, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17H24V19H22z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H4V5H26V3H4A2,2,0,0,0,2,5V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM4,26V10H28v3H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h8v3ZM28,15v6H20V15Z"
  })), children);
});
var Warning32 = /*#__PURE__*/React.forwardRef(function Warning32(_ref89, ref) {
  var children = _ref89.children,
      rest = _objectWithoutProperties(_ref89, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8H17V19H15zM16 22a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 22z"
  })), children);
});
var Warning24 = /*#__PURE__*/React.forwardRef(function Warning24(_ref90, ref) {
  var children = _ref90.children,
      rest = _objectWithoutProperties(_ref90, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8H17V19H15zM16 22a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 22z"
  })), children);
});
var Warning20 = /*#__PURE__*/React.forwardRef(function Warning20(_ref91, ref) {
  var children = _ref91.children,
      rest = _objectWithoutProperties(_ref91, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8H17V19H15zM16 22a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 22z"
  })), children);
});
var Warning16 = /*#__PURE__*/React.forwardRef(function Warning16(_ref92, ref) {
  var children = _ref92.children,
      rest = _objectWithoutProperties(_ref92, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4H8.5V9H7.5zM8 10.2c-.4 0-.8.3-.8.8s.3.8.8.8c.4 0 .8-.3.8-.8S8.4 10.2 8 10.2z"
  })), children);
});
var WarningAlt32 = /*#__PURE__*/React.forwardRef(function WarningAlt32(_ref93, ref) {
  var children = _ref93.children,
      rest = _objectWithoutProperties(_ref93, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 23zM15 12H17V21H15z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M29,30H3a1,1,0,0,1-.8872-1.4614l13-25a1,1,0,0,1,1.7744,0l13,25A1,1,0,0,1,29,30ZM4.6507,28H27.3493l.002-.0033L16.002,6.1714h-.004L4.6487,27.9967Z"
  })), children);
});
var WarningAlt24 = /*#__PURE__*/React.forwardRef(function WarningAlt24(_ref94, ref) {
  var children = _ref94.children,
      rest = _objectWithoutProperties(_ref94, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 23zM15 12H17V21H15z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M29,30H3a1,1,0,0,1-.8872-1.4614l13-25a1,1,0,0,1,1.7744,0l13,25A1,1,0,0,1,29,30ZM4.6507,28H27.3493l.002-.0033L16.002,6.1714h-.004L4.6487,27.9967Z"
  })), children);
});
var WarningAlt20 = /*#__PURE__*/React.forwardRef(function WarningAlt20(_ref95, ref) {
  var children = _ref95.children,
      rest = _objectWithoutProperties(_ref95, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 23zM15 12H17V21H15z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M29,30H3a1,1,0,0,1-.8872-1.4614l13-25a1,1,0,0,1,1.7744,0l13,25A1,1,0,0,1,29,30ZM4.6507,28H27.3493l.002-.0033L16.002,6.1714h-.004L4.6487,27.9967Z"
  })), children);
});
var WarningAlt16 = /*#__PURE__*/React.forwardRef(function WarningAlt16(_ref96, ref) {
  var children = _ref96.children,
      rest = _objectWithoutProperties(_ref96, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,14h-13c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2-0.1-0.3,0-0.5l6.5-12C7.7,1,8,0.9,8.2,1.1c0.1,0,0.2,0.1,0.2,0.2l6.5,12\tc0.1,0.2,0.1,0.3,0,0.5C14.9,13.9,14.7,14,14.5,14z M2.3,13h11.3L8,2.5L2.3,13z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6H8.5V9.5H7.5zM8 10.8c-.4 0-.8.3-.8.8s.3.8.8.8c.4 0 .8-.3.8-.8S8.4 10.8 8 10.8z"
  })), children);
});
var WarningAltFilled32 = /*#__PURE__*/React.forwardRef(function WarningAltFilled32(_ref97, ref) {
  var children = _ref97.children,
      rest = _objectWithoutProperties(_ref97, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.875,11h2.25V21h-2.25ZM16,27a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,27Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8872,28.5386l-13-25a1,1,0,0,0-1.7744,0l-13,25A1,1,0,0,0,3,30H29a1,1,0,0,0,.8872-1.4614ZM14.875,11h2.25V21h-2.25ZM16,27a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,27Z"
  })), children);
});
var WarningAltFilled24 = /*#__PURE__*/React.forwardRef(function WarningAltFilled24(_ref98, ref) {
  var children = _ref98.children,
      rest = _objectWithoutProperties(_ref98, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.875,11h2.25V21h-2.25ZM16,27a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,27Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8872,28.5386l-13-25a1,1,0,0,0-1.7744,0l-13,25A1,1,0,0,0,3,30H29a1,1,0,0,0,.8872-1.4614ZM14.875,11h2.25V21h-2.25ZM16,27a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,27Z"
  })), children);
});
var WarningAltFilled20 = /*#__PURE__*/React.forwardRef(function WarningAltFilled20(_ref99, ref) {
  var children = _ref99.children,
      rest = _objectWithoutProperties(_ref99, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.875,11h2.25V21h-2.25ZM16,27a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,27Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8872,28.5386l-13-25a1,1,0,0,0-1.7744,0l-13,25A1,1,0,0,0,3,30H29a1,1,0,0,0,.8872-1.4614ZM14.875,11h2.25V21h-2.25ZM16,27a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,27Z"
  })), children);
});
var WarningAltFilled16 = /*#__PURE__*/React.forwardRef(function WarningAltFilled16(_ref100, ref) {
  var children = _ref100.children,
      rest = _objectWithoutProperties(_ref100, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.875,11h2.25V21h-2.25ZM16,27a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,27Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8872,28.5386l-13-25a1,1,0,0,0-1.7744,0l-13,25A1,1,0,0,0,3,30H29a1,1,0,0,0,.8872-1.4614ZM14.875,11h2.25V21h-2.25ZM16,27a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,27Z"
  })), children);
});
var WarningAltInverted32 = /*#__PURE__*/React.forwardRef(function WarningAltInverted32(_ref101, ref) {
  var children = _ref101.children,
      rest = _objectWithoutProperties(_ref101, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 17zM15 6H17V15H15z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M29.855,2.481a1.001,1.001,0,0,1,.0322.98l-13,25a1,1,0,0,1-1.7744,0l-13-25A1,1,0,0,1,3,2H29A1.0007,1.0007,0,0,1,29.855,2.481ZM4.6487,4.0033,15.998,25.8286h.004L27.3513,4.0033,27.3493,4H4.6507Z"
  })), children);
});
var WarningAltInverted24 = /*#__PURE__*/React.forwardRef(function WarningAltInverted24(_ref102, ref) {
  var children = _ref102.children,
      rest = _objectWithoutProperties(_ref102, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 17zM15 6H17V15H15z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M29.855,2.481a1.001,1.001,0,0,1,.0322.98l-13,25a1,1,0,0,1-1.7744,0l-13-25A1,1,0,0,1,3,2H29A1.0007,1.0007,0,0,1,29.855,2.481ZM4.6487,4.0033,15.998,25.8286h.004L27.3513,4.0033,27.3493,4H4.6507Z"
  })), children);
});
var WarningAltInverted20 = /*#__PURE__*/React.forwardRef(function WarningAltInverted20(_ref103, ref) {
  var children = _ref103.children,
      rest = _objectWithoutProperties(_ref103, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 17zM15 6H17V15H15z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M29.855,2.481a1.001,1.001,0,0,1,.0322.98l-13,25a1,1,0,0,1-1.7744,0l-13-25A1,1,0,0,1,3,2H29A1.0007,1.0007,0,0,1,29.855,2.481ZM4.6487,4.0033,15.998,25.8286h.004L27.3513,4.0033,27.3493,4H4.6507Z"
  })), children);
});
var WarningAltInverted16 = /*#__PURE__*/React.forwardRef(function WarningAltInverted16(_ref104, ref) {
  var children = _ref104.children,
      rest = _objectWithoutProperties(_ref104, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 17zM15 6H17V15H15z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M29.855,2.481a1.001,1.001,0,0,1,.0322.98l-13,25a1,1,0,0,1-1.7744,0l-13-25A1,1,0,0,1,3,2H29A1.0007,1.0007,0,0,1,29.855,2.481ZM4.6487,4.0033,15.998,25.8286h.004L27.3513,4.0033,27.3493,4H4.6507Z"
  })), children);
});
var WarningAltInvertedFilled32 = /*#__PURE__*/React.forwardRef(function WarningAltInvertedFilled32(_ref105, ref) {
  var children = _ref105.children,
      rest = _objectWithoutProperties(_ref105, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.875,5h2.25V15h-2.25ZM16,21a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,21Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M29.855,2.481A1.0011,1.0011,0,0,0,29,2H3a1,1,0,0,0-.8872,1.4614l13,25a1,1,0,0,0,1.7744,0l13-25A1.001,1.001,0,0,0,29.855,2.481ZM14.875,5h2.25V15h-2.25ZM16,21a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,21Z"
  })), children);
});
var WarningAltInvertedFilled24 = /*#__PURE__*/React.forwardRef(function WarningAltInvertedFilled24(_ref106, ref) {
  var children = _ref106.children,
      rest = _objectWithoutProperties(_ref106, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.875,5h2.25V15h-2.25ZM16,21a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,21Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M29.855,2.481A1.0011,1.0011,0,0,0,29,2H3a1,1,0,0,0-.8872,1.4614l13,25a1,1,0,0,0,1.7744,0l13-25A1.001,1.001,0,0,0,29.855,2.481ZM14.875,5h2.25V15h-2.25ZM16,21a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,21Z"
  })), children);
});
var WarningAltInvertedFilled20 = /*#__PURE__*/React.forwardRef(function WarningAltInvertedFilled20(_ref107, ref) {
  var children = _ref107.children,
      rest = _objectWithoutProperties(_ref107, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.875,5h2.25V15h-2.25ZM16,21a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,21Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M29.855,2.481A1.0011,1.0011,0,0,0,29,2H3a1,1,0,0,0-.8872,1.4614l13,25a1,1,0,0,0,1.7744,0l13-25A1.001,1.001,0,0,0,29.855,2.481ZM14.875,5h2.25V15h-2.25ZM16,21a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,21Z"
  })), children);
});
var WarningAltInvertedFilled16 = /*#__PURE__*/React.forwardRef(function WarningAltInvertedFilled16(_ref108, ref) {
  var children = _ref108.children,
      rest = _objectWithoutProperties(_ref108, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.875,5h2.25V15h-2.25ZM16,21a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,21Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M29.855,2.481A1.0011,1.0011,0,0,0,29,2H3a1,1,0,0,0-.8872,1.4614l13,25a1,1,0,0,0,1.7744,0l13-25A1.001,1.001,0,0,0,29.855,2.481ZM14.875,5h2.25V15h-2.25ZM16,21a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,21Z"
  })), children);
});
var WarningFilled32 = /*#__PURE__*/React.forwardRef(function WarningFilled32(_ref109, ref) {
  var children = _ref109.children,
      rest = _objectWithoutProperties(_ref109, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14C30,8.3,23.7,2,16,2z M14.9,8h2.2v11h-2.2V8z M16,25\tc-0.8,0-1.5-0.7-1.5-1.5S15.2,22,16,22c0.8,0,1.5,0.7,1.5,1.5S16.8,25,16,25z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M17.5,23.5c0,0.8-0.7,1.5-1.5,1.5c-0.8,0-1.5-0.7-1.5-1.5S15.2,22,16,22\tC16.8,22,17.5,22.7,17.5,23.5z M17.1,8h-2.2v11h2.2V8z",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), children);
});
var WarningFilled24 = /*#__PURE__*/React.forwardRef(function WarningFilled24(_ref110, ref) {
  var children = _ref110.children,
      rest = _objectWithoutProperties(_ref110, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M12,1C5.9,1,1,5.9,1,12s4.9,11,11,11s11-4.9,11-11C23,5.9,18.1,1,12,1z M11.1,6h1.8v8h-1.8V6z M12,19.2\tc-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2S12.7,19.2,12,19.2z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M13.2,18c0,0.7-0.6,1.2-1.2,1.2s-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2S13.2,17.3,13.2,18z M12.9,6\th-1.8v8h1.8V6z",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), children);
});
var WarningFilled20 = /*#__PURE__*/React.forwardRef(function WarningFilled20(_ref111, ref) {
  var children = _ref111.children,
      rest = _objectWithoutProperties(_ref111, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M10,1c-5,0-9,4-9,9s4,9,9,9s9-4,9-9S15,1,10,1z M9.2,5h1.5v7H9.2V5z M10,16c-0.6,0-1-0.4-1-1s0.4-1,1-1\ts1,0.4,1,1S10.6,16,10,16z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2,5h1.5v7H9.2V5z M10,16c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S10.6,16,10,16z",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), children);
});
var WarningFilled16 = /*#__PURE__*/React.forwardRef(function WarningFilled16(_ref112, ref) {
  var children = _ref112.children,
      rest = _objectWithoutProperties(_ref112, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M8,1C4.2,1,1,4.2,1,8s3.2,7,7,7s7-3.1,7-7S11.9,1,8,1z M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2\tc-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2c-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8\tc0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), children);
});
var WarningHex32 = /*#__PURE__*/React.forwardRef(function WarningHex32(_ref113, ref) {
  var children = _ref113.children,
      rest = _objectWithoutProperties(_ref113, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 21zM15 8H17V18H15z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M23,29H9a1,1,0,0,1-.8638-.4961l-7-12a1,1,0,0,1,0-1.0078l7-12A1,1,0,0,1,9,3H23a1,1,0,0,1,.8638.4961l7,12a1,1,0,0,1,0,1.0078l-7,12A1,1,0,0,1,23,29ZM9.5742,27H22.4258l6.4165-11L22.4258,5H9.5742L3.1577,16Z"
  })), children);
});
var WarningHex24 = /*#__PURE__*/React.forwardRef(function WarningHex24(_ref114, ref) {
  var children = _ref114.children,
      rest = _objectWithoutProperties(_ref114, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 21zM15 8H17V18H15z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M23,29H9a1,1,0,0,1-.8638-.4961l-7-12a1,1,0,0,1,0-1.0078l7-12A1,1,0,0,1,9,3H23a1,1,0,0,1,.8638.4961l7,12a1,1,0,0,1,0,1.0078l-7,12A1,1,0,0,1,23,29ZM9.5742,27H22.4258l6.4165-11L22.4258,5H9.5742L3.1577,16Z"
  })), children);
});
var WarningHex20 = /*#__PURE__*/React.forwardRef(function WarningHex20(_ref115, ref) {
  var children = _ref115.children,
      rest = _objectWithoutProperties(_ref115, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 21zM15 8H17V18H15z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M23,29H9a1,1,0,0,1-.8638-.4961l-7-12a1,1,0,0,1,0-1.0078l7-12A1,1,0,0,1,9,3H23a1,1,0,0,1,.8638.4961l7,12a1,1,0,0,1,0,1.0078l-7,12A1,1,0,0,1,23,29ZM9.5742,27H22.4258l6.4165-11L22.4258,5H9.5742L3.1577,16Z"
  })), children);
});
var WarningHex16 = /*#__PURE__*/React.forwardRef(function WarningHex16(_ref116, ref) {
  var children = _ref116.children,
      rest = _objectWithoutProperties(_ref116, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 21zM15 8H17V18H15z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M23,29H9a1,1,0,0,1-.8638-.4961l-7-12a1,1,0,0,1,0-1.0078l7-12A1,1,0,0,1,9,3H23a1,1,0,0,1,.8638.4961l7,12a1,1,0,0,1,0,1.0078l-7,12A1,1,0,0,1,23,29ZM9.5742,27H22.4258l6.4165-11L22.4258,5H9.5742L3.1577,16Z"
  })), children);
});
var WarningHexFilled32 = /*#__PURE__*/React.forwardRef(function WarningHexFilled32(_ref117, ref) {
  var children = _ref117.children,
      rest = _objectWithoutProperties(_ref117, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8508,15.4487,23.8867,3.5322A1.0687,1.0687,0,0,0,22.9643,3H9.0357a1.0687,1.0687,0,0,0-.9224.5322L1.1492,15.4487a1.0933,1.0933,0,0,0,0,1.1026L8.1133,28.4678A1.0687,1.0687,0,0,0,9.0357,29H22.9643a1.0687,1.0687,0,0,0,.9224-.5322l6.9641-11.9165A1.0933,1.0933,0,0,0,30.8508,15.4487ZM14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z"
  })), children);
});
var WarningHexFilled24 = /*#__PURE__*/React.forwardRef(function WarningHexFilled24(_ref118, ref) {
  var children = _ref118.children,
      rest = _objectWithoutProperties(_ref118, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8508,15.4487,23.8867,3.5322A1.0687,1.0687,0,0,0,22.9643,3H9.0357a1.0687,1.0687,0,0,0-.9224.5322L1.1492,15.4487a1.0933,1.0933,0,0,0,0,1.1026L8.1133,28.4678A1.0687,1.0687,0,0,0,9.0357,29H22.9643a1.0687,1.0687,0,0,0,.9224-.5322l6.9641-11.9165A1.0933,1.0933,0,0,0,30.8508,15.4487ZM14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z"
  })), children);
});
var WarningHexFilled20 = /*#__PURE__*/React.forwardRef(function WarningHexFilled20(_ref119, ref) {
  var children = _ref119.children,
      rest = _objectWithoutProperties(_ref119, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8508,15.4487,23.8867,3.5322A1.0687,1.0687,0,0,0,22.9643,3H9.0357a1.0687,1.0687,0,0,0-.9224.5322L1.1492,15.4487a1.0933,1.0933,0,0,0,0,1.1026L8.1133,28.4678A1.0687,1.0687,0,0,0,9.0357,29H22.9643a1.0687,1.0687,0,0,0,.9224-.5322l6.9641-11.9165A1.0933,1.0933,0,0,0,30.8508,15.4487ZM14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z"
  })), children);
});
var WarningHexFilled16 = /*#__PURE__*/React.forwardRef(function WarningHexFilled16(_ref120, ref) {
  var children = _ref120.children,
      rest = _objectWithoutProperties(_ref120, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8508,15.4487,23.8867,3.5322A1.0687,1.0687,0,0,0,22.9643,3H9.0357a1.0687,1.0687,0,0,0-.9224.5322L1.1492,15.4487a1.0933,1.0933,0,0,0,0,1.1026L8.1133,28.4678A1.0687,1.0687,0,0,0,9.0357,29H22.9643a1.0687,1.0687,0,0,0,.9224-.5322l6.9641-11.9165A1.0933,1.0933,0,0,0,30.8508,15.4487ZM14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z"
  })), children);
});
var WarningOther32 = /*#__PURE__*/React.forwardRef(function WarningOther32(_ref121, ref) {
  var children = _ref121.children,
      rest = _objectWithoutProperties(_ref121, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20H30V22H18zM18 24H30V26H18zM18 28H30V30H18zM14 18a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0014 18zM13 7H15V16H13z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M14,4A10.0111,10.0111,0,0,1,24,14h2A12,12,0,1,0,14,26V24A10,10,0,0,1,14,4Z"
  })), children);
});
var WarningOther24 = /*#__PURE__*/React.forwardRef(function WarningOther24(_ref122, ref) {
  var children = _ref122.children,
      rest = _objectWithoutProperties(_ref122, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20H30V22H18zM18 24H30V26H18zM18 28H30V30H18zM14 18a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0014 18zM13 7H15V16H13z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M14,4A10.0111,10.0111,0,0,1,24,14h2A12,12,0,1,0,14,26V24A10,10,0,0,1,14,4Z"
  })), children);
});
var WarningOther20 = /*#__PURE__*/React.forwardRef(function WarningOther20(_ref123, ref) {
  var children = _ref123.children,
      rest = _objectWithoutProperties(_ref123, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20H30V22H18zM18 24H30V26H18zM18 28H30V30H18zM14 18a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0014 18zM13 7H15V16H13z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M14,4A10.0111,10.0111,0,0,1,24,14h2A12,12,0,1,0,14,26V24A10,10,0,0,1,14,4Z"
  })), children);
});
var WarningOther16 = /*#__PURE__*/React.forwardRef(function WarningOther16(_ref124, ref) {
  var children = _ref124.children,
      rest = _objectWithoutProperties(_ref124, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20H30V22H18zM18 24H30V26H18zM18 28H30V30H18zM14 18a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0014 18zM13 7H15V16H13z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M14,4A10.0111,10.0111,0,0,1,24,14h2A12,12,0,1,0,14,26V24A10,10,0,0,1,14,4Z"
  })), children);
});
var WarningSquare32 = /*#__PURE__*/React.forwardRef(function WarningSquare32(_ref125, ref) {
  var children = _ref125.children,
      rest = _objectWithoutProperties(_ref125, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 20zM15 9H17V18H15z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
  })), children);
});
var WarningSquare24 = /*#__PURE__*/React.forwardRef(function WarningSquare24(_ref126, ref) {
  var children = _ref126.children,
      rest = _objectWithoutProperties(_ref126, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 20zM15 9H17V18H15z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
  })), children);
});
var WarningSquare20 = /*#__PURE__*/React.forwardRef(function WarningSquare20(_ref127, ref) {
  var children = _ref127.children,
      rest = _objectWithoutProperties(_ref127, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 20zM15 9H17V18H15z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
  })), children);
});
var WarningSquare16 = /*#__PURE__*/React.forwardRef(function WarningSquare16(_ref128, ref) {
  var children = _ref128.children,
      rest = _objectWithoutProperties(_ref128, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 20zM15 9H17V18H15z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
  })), children);
});
var WarningSquareFilled32 = /*#__PURE__*/React.forwardRef(function WarningSquareFilled32(_ref129, ref) {
  var children = _ref129.children,
      rest = _objectWithoutProperties(_ref129, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0022,4H5.998A1.998,1.998,0,0,0,4,5.998V26.002A1.998,1.998,0,0,0,5.998,28H26.0022A1.9979,1.9979,0,0,0,28,26.002V5.998A1.9979,1.9979,0,0,0,26.0022,4ZM14.8752,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.8751,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z",
    "data-icon-path": "inner-path"
  })), children);
});
var WarningSquareFilled24 = /*#__PURE__*/React.forwardRef(function WarningSquareFilled24(_ref130, ref) {
  var children = _ref130.children,
      rest = _objectWithoutProperties(_ref130, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0022,4H5.998A1.998,1.998,0,0,0,4,5.998V26.002A1.998,1.998,0,0,0,5.998,28H26.0022A1.9979,1.9979,0,0,0,28,26.002V5.998A1.9979,1.9979,0,0,0,26.0022,4ZM14.8752,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.8751,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z",
    "data-icon-path": "inner-path"
  })), children);
});
var WarningSquareFilled20 = /*#__PURE__*/React.forwardRef(function WarningSquareFilled20(_ref131, ref) {
  var children = _ref131.children,
      rest = _objectWithoutProperties(_ref131, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0022,4H5.998A1.998,1.998,0,0,0,4,5.998V26.002A1.998,1.998,0,0,0,5.998,28H26.0022A1.9979,1.9979,0,0,0,28,26.002V5.998A1.9979,1.9979,0,0,0,26.0022,4ZM14.8752,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.8751,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z",
    "data-icon-path": "inner-path"
  })), children);
});
var WarningSquareFilled16 = /*#__PURE__*/React.forwardRef(function WarningSquareFilled16(_ref132, ref) {
  var children = _ref132.children,
      rest = _objectWithoutProperties(_ref132, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0022,4H5.998A1.998,1.998,0,0,0,4,5.998V26.002A1.998,1.998,0,0,0,5.998,28H26.0022A1.9979,1.9979,0,0,0,28,26.002V5.998A1.9979,1.9979,0,0,0,26.0022,4ZM14.8752,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.8751,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z",
    "data-icon-path": "inner-path"
  })), children);
});
var Watch32 = /*#__PURE__*/React.forwardRef(function Watch32(_ref133, ref) {
  var children = _ref133.children,
      rest = _objectWithoutProperties(_ref133, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8H21V2H19V8H13V2H11V8H10a2 2 0 00-2 2V22a2 2 0 002 2h1v6h2V24h6v6h2V24h1a2 2 0 002-2V10A2 2 0 0022 8zM10 22V10H22V22zM25 14H27V18H25z"
  })), children);
});
var Watch24 = /*#__PURE__*/React.forwardRef(function Watch24(_ref134, ref) {
  var children = _ref134.children,
      rest = _objectWithoutProperties(_ref134, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8H21V2H19V8H13V2H11V8H10a2 2 0 00-2 2V22a2 2 0 002 2h1v6h2V24h6v6h2V24h1a2 2 0 002-2V10A2 2 0 0022 8zM10 22V10H22V22zM25 14H27V18H25z"
  })), children);
});
var Watch20 = /*#__PURE__*/React.forwardRef(function Watch20(_ref135, ref) {
  var children = _ref135.children,
      rest = _objectWithoutProperties(_ref135, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8H21V2H19V8H13V2H11V8H10a2 2 0 00-2 2V22a2 2 0 002 2h1v6h2V24h6v6h2V24h1a2 2 0 002-2V10A2 2 0 0022 8zM10 22V10H22V22zM25 14H27V18H25z"
  })), children);
});
var Watch16 = /*#__PURE__*/React.forwardRef(function Watch16(_ref136, ref) {
  var children = _ref136.children,
      rest = _objectWithoutProperties(_ref136, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8H21V2H19V8H13V2H11V8H10a2 2 0 00-2 2V22a2 2 0 002 2h1v6h2V24h6v6h2V24h1a2 2 0 002-2V10A2 2 0 0022 8zM10 22V10H22V22zM25 14H27V18H25z"
  })), children);
});
var Watson32 = /*#__PURE__*/React.forwardRef(function Watson32(_ref137, ref) {
  var children = _ref137.children,
      rest = _objectWithoutProperties(_ref137, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M21.74 9.49h0A11.41 11.41 0 0016 8h0a.76.76 0 100 1.51 10.15 10.15 0 011.91.21c-2.26 1.08-4.76 3.58-6.73 7a22.48 22.48 0 00-2 4.44A9.58 9.58 0 017 17.22a3.43 3.43 0 01.28-2.66v0h0c.79-1.37 2.44-2.15 4.63-2.2a.76.76 0 00.74-.78.75.75 0 00-.78-.74C9.19 10.88 7.1 11.92 6 13.74H6v0s0 0 0 0a4.84 4.84 0 00-.44 3.79 12 12 0 003.2 5.22A11.36 11.36 0 008.52 26a10 10 0 01-2-3.48A.75.75 0 005.57 22a.76.76 0 00-.49 1 11.45 11.45 0 005.18 6.38h0A11.42 11.42 0 0016 30.92a11.74 11.74 0 003-.39 11.48 11.48 0 002.77-21zM18.58 29.06a9.9 9.9 0 01-7.56-1h0c-.86-.49-1.21-2-.94-4a18.85 18.85 0 002.48 1.72 13.92 13.92 0 006.93 2 11 11 0 002.42-.28A9.78 9.78 0 0118.58 29.06zm6.06-4.66c-2 2-6.66 2.74-11.32.05a17.36 17.36 0 01-2.89-2.12 21.08 21.08 0 012.08-4.91c2.94-5.08 6.83-7.57 8.47-6.62h0A10 10 0 0124.64 24.4zM4.16 11.72L1.14 10a.76.76 0 10-.76 1.31L3.4 13a.86.86 0 00.38.1.77.77 0 00.66-.38A.76.76 0 004.16 11.72zM8.29 7.59A.74.74 0 008.94 8a.75.75 0 00.38-.1.76.76 0 00.28-1l-1.74-3a.76.76 0 00-1-.27.75.75 0 00-.28 1zM16 6.08a.76.76 0 00.76-.76V1.83a.76.76 0 00-1.52 0V5.32A.76.76 0 0016 6.08zM22.68 7.87a.75.75 0 001-.28l1.75-3a.75.75 0 00-.28-1 .76.76 0 00-1 .27l-1.74 3A.76.76 0 0022.68 7.87zM31.9 10.25a.76.76 0 00-1-.27l-3 1.74a.76.76 0 00-.28 1 .77.77 0 00.66.38.86.86 0 00.38-.1l3-1.75A.76.76 0 0031.9 10.25z"
  })), children);
});
var Watson24 = /*#__PURE__*/React.forwardRef(function Watson24(_ref138, ref) {
  var children = _ref138.children,
      rest = _objectWithoutProperties(_ref138, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M21.74 9.49h0A11.41 11.41 0 0016 8h0a.76.76 0 100 1.51 10.15 10.15 0 011.91.21c-2.26 1.08-4.76 3.58-6.73 7a22.48 22.48 0 00-2 4.44A9.58 9.58 0 017 17.22a3.43 3.43 0 01.28-2.66v0h0c.79-1.37 2.44-2.15 4.63-2.2a.76.76 0 00.74-.78.75.75 0 00-.78-.74C9.19 10.88 7.1 11.92 6 13.74H6v0s0 0 0 0a4.84 4.84 0 00-.44 3.79 12 12 0 003.2 5.22A11.36 11.36 0 008.52 26a10 10 0 01-2-3.48A.75.75 0 005.57 22a.76.76 0 00-.49 1 11.45 11.45 0 005.18 6.38h0A11.42 11.42 0 0016 30.92a11.74 11.74 0 003-.39 11.48 11.48 0 002.77-21zM18.58 29.06a9.9 9.9 0 01-7.56-1h0c-.86-.49-1.21-2-.94-4a18.85 18.85 0 002.48 1.72 13.92 13.92 0 006.93 2 11 11 0 002.42-.28A9.78 9.78 0 0118.58 29.06zm6.06-4.66c-2 2-6.66 2.74-11.32.05a17.36 17.36 0 01-2.89-2.12 21.08 21.08 0 012.08-4.91c2.94-5.08 6.83-7.57 8.47-6.62h0A10 10 0 0124.64 24.4zM4.16 11.72L1.14 10a.76.76 0 10-.76 1.31L3.4 13a.86.86 0 00.38.1.77.77 0 00.66-.38A.76.76 0 004.16 11.72zM8.29 7.59A.74.74 0 008.94 8a.75.75 0 00.38-.1.76.76 0 00.28-1l-1.74-3a.76.76 0 00-1-.27.75.75 0 00-.28 1zM16 6.08a.76.76 0 00.76-.76V1.83a.76.76 0 00-1.52 0V5.32A.76.76 0 0016 6.08zM22.68 7.87a.75.75 0 001-.28l1.75-3a.75.75 0 00-.28-1 .76.76 0 00-1 .27l-1.74 3A.76.76 0 0022.68 7.87zM31.9 10.25a.76.76 0 00-1-.27l-3 1.74a.76.76 0 00-.28 1 .77.77 0 00.66.38.86.86 0 00.38-.1l3-1.75A.76.76 0 0031.9 10.25z"
  })), children);
});
var Watson20 = /*#__PURE__*/React.forwardRef(function Watson20(_ref139, ref) {
  var children = _ref139.children,
      rest = _objectWithoutProperties(_ref139, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M21.74 9.49h0A11.41 11.41 0 0016 8h0a.76.76 0 100 1.51 10.15 10.15 0 011.91.21c-2.26 1.08-4.76 3.58-6.73 7a22.48 22.48 0 00-2 4.44A9.58 9.58 0 017 17.22a3.43 3.43 0 01.28-2.66v0h0c.79-1.37 2.44-2.15 4.63-2.2a.76.76 0 00.74-.78.75.75 0 00-.78-.74C9.19 10.88 7.1 11.92 6 13.74H6v0s0 0 0 0a4.84 4.84 0 00-.44 3.79 12 12 0 003.2 5.22A11.36 11.36 0 008.52 26a10 10 0 01-2-3.48A.75.75 0 005.57 22a.76.76 0 00-.49 1 11.45 11.45 0 005.18 6.38h0A11.42 11.42 0 0016 30.92a11.74 11.74 0 003-.39 11.48 11.48 0 002.77-21zM18.58 29.06a9.9 9.9 0 01-7.56-1h0c-.86-.49-1.21-2-.94-4a18.85 18.85 0 002.48 1.72 13.92 13.92 0 006.93 2 11 11 0 002.42-.28A9.78 9.78 0 0118.58 29.06zm6.06-4.66c-2 2-6.66 2.74-11.32.05a17.36 17.36 0 01-2.89-2.12 21.08 21.08 0 012.08-4.91c2.94-5.08 6.83-7.57 8.47-6.62h0A10 10 0 0124.64 24.4zM4.16 11.72L1.14 10a.76.76 0 10-.76 1.31L3.4 13a.86.86 0 00.38.1.77.77 0 00.66-.38A.76.76 0 004.16 11.72zM8.29 7.59A.74.74 0 008.94 8a.75.75 0 00.38-.1.76.76 0 00.28-1l-1.74-3a.76.76 0 00-1-.27.75.75 0 00-.28 1zM16 6.08a.76.76 0 00.76-.76V1.83a.76.76 0 00-1.52 0V5.32A.76.76 0 0016 6.08zM22.68 7.87a.75.75 0 001-.28l1.75-3a.75.75 0 00-.28-1 .76.76 0 00-1 .27l-1.74 3A.76.76 0 0022.68 7.87zM31.9 10.25a.76.76 0 00-1-.27l-3 1.74a.76.76 0 00-.28 1 .77.77 0 00.66.38.86.86 0 00.38-.1l3-1.75A.76.76 0 0031.9 10.25z"
  })), children);
});
var Watson16 = /*#__PURE__*/React.forwardRef(function Watson16(_ref140, ref) {
  var children = _ref140.children,
      rest = _objectWithoutProperties(_ref140, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M21.74 9.49h0A11.41 11.41 0 0016 8h0a.76.76 0 100 1.51 10.15 10.15 0 011.91.21c-2.26 1.08-4.76 3.58-6.73 7a22.48 22.48 0 00-2 4.44A9.58 9.58 0 017 17.22a3.43 3.43 0 01.28-2.66v0h0c.79-1.37 2.44-2.15 4.63-2.2a.76.76 0 00.74-.78.75.75 0 00-.78-.74C9.19 10.88 7.1 11.92 6 13.74H6v0s0 0 0 0a4.84 4.84 0 00-.44 3.79 12 12 0 003.2 5.22A11.36 11.36 0 008.52 26a10 10 0 01-2-3.48A.75.75 0 005.57 22a.76.76 0 00-.49 1 11.45 11.45 0 005.18 6.38h0A11.42 11.42 0 0016 30.92a11.74 11.74 0 003-.39 11.48 11.48 0 002.77-21zM18.58 29.06a9.9 9.9 0 01-7.56-1h0c-.86-.49-1.21-2-.94-4a18.85 18.85 0 002.48 1.72 13.92 13.92 0 006.93 2 11 11 0 002.42-.28A9.78 9.78 0 0118.58 29.06zm6.06-4.66c-2 2-6.66 2.74-11.32.05a17.36 17.36 0 01-2.89-2.12 21.08 21.08 0 012.08-4.91c2.94-5.08 6.83-7.57 8.47-6.62h0A10 10 0 0124.64 24.4zM4.16 11.72L1.14 10a.76.76 0 10-.76 1.31L3.4 13a.86.86 0 00.38.1.77.77 0 00.66-.38A.76.76 0 004.16 11.72zM8.29 7.59A.74.74 0 008.94 8a.75.75 0 00.38-.1.76.76 0 00.28-1l-1.74-3a.76.76 0 00-1-.27.75.75 0 00-.28 1zM16 6.08a.76.76 0 00.76-.76V1.83a.76.76 0 00-1.52 0V5.32A.76.76 0 0016 6.08zM22.68 7.87a.75.75 0 001-.28l1.75-3a.75.75 0 00-.28-1 .76.76 0 00-1 .27l-1.74 3A.76.76 0 0022.68 7.87zM31.9 10.25a.76.76 0 00-1-.27l-3 1.74a.76.76 0 00-.28 1 .77.77 0 00.66.38.86.86 0 00.38-.1l3-1.75A.76.76 0 0031.9 10.25z"
  })), children);
});
var WatsonMachineLearning32 = /*#__PURE__*/React.forwardRef(function WatsonMachineLearning32(_ref141, ref) {
  var children = _ref141.children,
      rest = _objectWithoutProperties(_ref141, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26H20V17.76l-3.23 3.88a1 1 0 01-1.54 0L12 17.76V26H10V15a1 1 0 01.66-.94 1 1 0 011.11.3L16 19.44l4.23-5.08a1 1 0 011.11-.3A1 1 0 0122 15zM4.16 14.65l-3-1.75a.76.76 0 10-.76 1.32L3.4 16a.76.76 0 10.76-1.31zM8.29 10.52a.73.73 0 001 .27.75.75 0 00.28-1l-1.74-3a.76.76 0 10-1.32.76zM16 9a.76.76 0 00.76-.76V4.76a.76.76 0 10-1.52 0V8.25A.76.76 0 0016 9zM22.68 10.79a.75.75 0 00.37.11.76.76 0 00.66-.38l1.75-3a.76.76 0 00-1.32-.76l-1.74 3A.75.75 0 0022.68 10.79zM31.9 13.18a.76.76 0 00-1-.28l-3 1.75A.76.76 0 0028.6 16l3-1.74A.77.77 0 0031.9 13.18z"
  })), children);
});
var WatsonMachineLearning24 = /*#__PURE__*/React.forwardRef(function WatsonMachineLearning24(_ref142, ref) {
  var children = _ref142.children,
      rest = _objectWithoutProperties(_ref142, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26H20V17.76l-3.23 3.88a1 1 0 01-1.54 0L12 17.76V26H10V15a1 1 0 01.66-.94 1 1 0 011.11.3L16 19.44l4.23-5.08a1 1 0 011.11-.3A1 1 0 0122 15zM4.16 14.65l-3-1.75a.76.76 0 10-.76 1.32L3.4 16a.76.76 0 10.76-1.31zM8.29 10.52a.73.73 0 001 .27.75.75 0 00.28-1l-1.74-3a.76.76 0 10-1.32.76zM16 9a.76.76 0 00.76-.76V4.76a.76.76 0 10-1.52 0V8.25A.76.76 0 0016 9zM22.68 10.79a.75.75 0 00.37.11.76.76 0 00.66-.38l1.75-3a.76.76 0 00-1.32-.76l-1.74 3A.75.75 0 0022.68 10.79zM31.9 13.18a.76.76 0 00-1-.28l-3 1.75A.76.76 0 0028.6 16l3-1.74A.77.77 0 0031.9 13.18z"
  })), children);
});
var WatsonMachineLearning20 = /*#__PURE__*/React.forwardRef(function WatsonMachineLearning20(_ref143, ref) {
  var children = _ref143.children,
      rest = _objectWithoutProperties(_ref143, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26H20V17.76l-3.23 3.88a1 1 0 01-1.54 0L12 17.76V26H10V15a1 1 0 01.66-.94 1 1 0 011.11.3L16 19.44l4.23-5.08a1 1 0 011.11-.3A1 1 0 0122 15zM4.16 14.65l-3-1.75a.76.76 0 10-.76 1.32L3.4 16a.76.76 0 10.76-1.31zM8.29 10.52a.73.73 0 001 .27.75.75 0 00.28-1l-1.74-3a.76.76 0 10-1.32.76zM16 9a.76.76 0 00.76-.76V4.76a.76.76 0 10-1.52 0V8.25A.76.76 0 0016 9zM22.68 10.79a.75.75 0 00.37.11.76.76 0 00.66-.38l1.75-3a.76.76 0 00-1.32-.76l-1.74 3A.75.75 0 0022.68 10.79zM31.9 13.18a.76.76 0 00-1-.28l-3 1.75A.76.76 0 0028.6 16l3-1.74A.77.77 0 0031.9 13.18z"
  })), children);
});
var WatsonMachineLearning16 = /*#__PURE__*/React.forwardRef(function WatsonMachineLearning16(_ref144, ref) {
  var children = _ref144.children,
      rest = _objectWithoutProperties(_ref144, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26H20V17.76l-3.23 3.88a1 1 0 01-1.54 0L12 17.76V26H10V15a1 1 0 01.66-.94 1 1 0 011.11.3L16 19.44l4.23-5.08a1 1 0 011.11-.3A1 1 0 0122 15zM4.16 14.65l-3-1.75a.76.76 0 10-.76 1.32L3.4 16a.76.76 0 10.76-1.31zM8.29 10.52a.73.73 0 001 .27.75.75 0 00.28-1l-1.74-3a.76.76 0 10-1.32.76zM16 9a.76.76 0 00.76-.76V4.76a.76.76 0 10-1.52 0V8.25A.76.76 0 0016 9zM22.68 10.79a.75.75 0 00.37.11.76.76 0 00.66-.38l1.75-3a.76.76 0 00-1.32-.76l-1.74 3A.75.75 0 0022.68 10.79zM31.9 13.18a.76.76 0 00-1-.28l-3 1.75A.76.76 0 0028.6 16l3-1.74A.77.77 0 0031.9 13.18z"
  })), children);
});
var WaveDirection32 = /*#__PURE__*/React.forwardRef(function WaveDirection32(_ref145, ref) {
  var children = _ref145.children,
      rest = _objectWithoutProperties(_ref145, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H17a7.0078,7.0078,0,0,1-7-7,6.6832,6.6832,0,0,1,2.0244-4.6967A6.7126,6.7126,0,0,0,10.0093,18C5.0425,18.0466,4,24.5513,4,30H2C2,18.4907,6.3452,16.0342,9.9907,16a10.0962,10.0962,0,0,1,4.4785,1.117,1,1,0,0,1,.0616,1.73A4.8773,4.8773,0,0,0,17,28h5Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M18,24V22a8,8,0,1,0-8-8H8A10,10,0,1,1,18,24Z"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "8",
    r: "1"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M23,17.5859l-2.3-2.3007A2.9665,2.9665,0,0,0,21,14a3.0033,3.0033,0,0,0-3-3,2.9609,2.9609,0,0,0-1.2854.3008L14.4141,9,13,10.4141l2.3,2.3007A2.9665,2.9665,0,0,0,15,14a3.0033,3.0033,0,0,0,3,3,2.9609,2.9609,0,0,0,1.2854-.3008L21.5859,19ZM17,14a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,17,14Z"
  })), children);
});
var WaveDirection24 = /*#__PURE__*/React.forwardRef(function WaveDirection24(_ref146, ref) {
  var children = _ref146.children,
      rest = _objectWithoutProperties(_ref146, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H17a7.0078,7.0078,0,0,1-7-7,6.6832,6.6832,0,0,1,2.0244-4.6967A6.7126,6.7126,0,0,0,10.0093,18C5.0425,18.0466,4,24.5513,4,30H2C2,18.4907,6.3452,16.0342,9.9907,16a10.0962,10.0962,0,0,1,4.4785,1.117,1,1,0,0,1,.0616,1.73A4.8773,4.8773,0,0,0,17,28h5Z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M18,24V22a8,8,0,1,0-8-8H8A10,10,0,1,1,18,24Z"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "8",
    r: "1"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M23,17.5859l-2.3-2.3007A2.9665,2.9665,0,0,0,21,14a3.0033,3.0033,0,0,0-3-3,2.9609,2.9609,0,0,0-1.2854.3008L14.4141,9,13,10.4141l2.3,2.3007A2.9665,2.9665,0,0,0,15,14a3.0033,3.0033,0,0,0,3,3,2.9609,2.9609,0,0,0,1.2854-.3008L21.5859,19ZM17,14a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,17,14Z"
  })), children);
});
var WaveDirection20 = /*#__PURE__*/React.forwardRef(function WaveDirection20(_ref147, ref) {
  var children = _ref147.children,
      rest = _objectWithoutProperties(_ref147, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H17a7.0078,7.0078,0,0,1-7-7,6.6832,6.6832,0,0,1,2.0244-4.6967A6.7126,6.7126,0,0,0,10.0093,18C5.0425,18.0466,4,24.5513,4,30H2C2,18.4907,6.3452,16.0342,9.9907,16a10.0962,10.0962,0,0,1,4.4785,1.117,1,1,0,0,1,.0616,1.73A4.8773,4.8773,0,0,0,17,28h5Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M18,24V22a8,8,0,1,0-8-8H8A10,10,0,1,1,18,24Z"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "8",
    r: "1"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M23,17.5859l-2.3-2.3007A2.9665,2.9665,0,0,0,21,14a3.0033,3.0033,0,0,0-3-3,2.9609,2.9609,0,0,0-1.2854.3008L14.4141,9,13,10.4141l2.3,2.3007A2.9665,2.9665,0,0,0,15,14a3.0033,3.0033,0,0,0,3,3,2.9609,2.9609,0,0,0,1.2854-.3008L21.5859,19ZM17,14a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,17,14Z"
  })), children);
});
var WaveDirection16 = /*#__PURE__*/React.forwardRef(function WaveDirection16(_ref148, ref) {
  var children = _ref148.children,
      rest = _objectWithoutProperties(_ref148, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H17a7.0078,7.0078,0,0,1-7-7,6.6832,6.6832,0,0,1,2.0244-4.6967A6.7126,6.7126,0,0,0,10.0093,18C5.0425,18.0466,4,24.5513,4,30H2C2,18.4907,6.3452,16.0342,9.9907,16a10.0962,10.0962,0,0,1,4.4785,1.117,1,1,0,0,1,.0616,1.73A4.8773,4.8773,0,0,0,17,28h5Z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M18,24V22a8,8,0,1,0-8-8H8A10,10,0,1,1,18,24Z"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "8",
    r: "1"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M23,17.5859l-2.3-2.3007A2.9665,2.9665,0,0,0,21,14a3.0033,3.0033,0,0,0-3-3,2.9609,2.9609,0,0,0-1.2854.3008L14.4141,9,13,10.4141l2.3,2.3007A2.9665,2.9665,0,0,0,15,14a3.0033,3.0033,0,0,0,3,3,2.9609,2.9609,0,0,0,1.2854-.3008L21.5859,19ZM17,14a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,17,14Z"
  })), children);
});
var WaveHeight32 = /*#__PURE__*/React.forwardRef(function WaveHeight32(_ref149, ref) {
  var children = _ref149.children,
      rest = _objectWithoutProperties(_ref149, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M24 2H30V4H24zM24 8H28V10H24zM24 14H30V16H24zM24 20H28V22H24z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28H24a10.0349,10.0349,0,0,1-6.9268-17.2622A11.9629,11.9629,0,0,0,12.9937,10a6.9027,6.9027,0,0,0-6.0308,3.42C4.9966,16.4348,4,21.34,4,28H2c0-7.0542,1.106-12.3274,3.2871-15.6726A8.906,8.906,0,0,1,12.9937,8h.0068a14.762,14.762,0,0,1,6.4619,1.592,1,1,0,0,1,.0869,1.7222A8.0249,8.0249,0,0,0,24,26h6Z"
  })), children);
});
var WaveHeight24 = /*#__PURE__*/React.forwardRef(function WaveHeight24(_ref150, ref) {
  var children = _ref150.children,
      rest = _objectWithoutProperties(_ref150, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M24 2H30V4H24zM24 8H28V10H24zM24 14H30V16H24zM24 20H28V22H24z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28H24a10.0349,10.0349,0,0,1-6.9268-17.2622A11.9629,11.9629,0,0,0,12.9937,10a6.9027,6.9027,0,0,0-6.0308,3.42C4.9966,16.4348,4,21.34,4,28H2c0-7.0542,1.106-12.3274,3.2871-15.6726A8.906,8.906,0,0,1,12.9937,8h.0068a14.762,14.762,0,0,1,6.4619,1.592,1,1,0,0,1,.0869,1.7222A8.0249,8.0249,0,0,0,24,26h6Z"
  })), children);
});
var WaveHeight20 = /*#__PURE__*/React.forwardRef(function WaveHeight20(_ref151, ref) {
  var children = _ref151.children,
      rest = _objectWithoutProperties(_ref151, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M24 2H30V4H24zM24 8H28V10H24zM24 14H30V16H24zM24 20H28V22H24z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28H24a10.0349,10.0349,0,0,1-6.9268-17.2622A11.9629,11.9629,0,0,0,12.9937,10a6.9027,6.9027,0,0,0-6.0308,3.42C4.9966,16.4348,4,21.34,4,28H2c0-7.0542,1.106-12.3274,3.2871-15.6726A8.906,8.906,0,0,1,12.9937,8h.0068a14.762,14.762,0,0,1,6.4619,1.592,1,1,0,0,1,.0869,1.7222A8.0249,8.0249,0,0,0,24,26h6Z"
  })), children);
});
var WaveHeight16 = /*#__PURE__*/React.forwardRef(function WaveHeight16(_ref152, ref) {
  var children = _ref152.children,
      rest = _objectWithoutProperties(_ref152, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M24 2H30V4H24zM24 8H28V10H24zM24 14H30V16H24zM24 20H28V22H24z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28H24a10.0349,10.0349,0,0,1-6.9268-17.2622A11.9629,11.9629,0,0,0,12.9937,10a6.9027,6.9027,0,0,0-6.0308,3.42C4.9966,16.4348,4,21.34,4,28H2c0-7.0542,1.106-12.3274,3.2871-15.6726A8.906,8.906,0,0,1,12.9937,8h.0068a14.762,14.762,0,0,1,6.4619,1.592,1,1,0,0,1,.0869,1.7222A8.0249,8.0249,0,0,0,24,26h6Z"
  })), children);
});
var WavePeriod32 = /*#__PURE__*/React.forwardRef(function WavePeriod32(_ref153, ref) {
  var children = _ref153.children,
      rest = _objectWithoutProperties(_ref153, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30H17a7.0078 7.0078 0 01-7-7 6.6832 6.6832 0 012.0244-4.6967A6.7935 6.7935 0 0010.0093 18C5.0425 18.0466 4 24.5513 4 30H2C2 18.4907 6.3452 16.0342 9.9907 16a10.0717 10.0717 0 014.4785 1.117 1 1 0 01.0616 1.73A4.8773 4.8773 0 0017 28h5zM17 8H19V16H17z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M28,5.4141,26.5859,4,24.3242,6.2617A9.95,9.95,0,0,0,19,4.0508V2H17V4.0508A10.0132,10.0132,0,0,0,8,14h2a8,8,0,1,1,8,8v2A9.9928,9.9928,0,0,0,25.7383,7.6758Z"
  })), children);
});
var WavePeriod24 = /*#__PURE__*/React.forwardRef(function WavePeriod24(_ref154, ref) {
  var children = _ref154.children,
      rest = _objectWithoutProperties(_ref154, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30H17a7.0078 7.0078 0 01-7-7 6.6832 6.6832 0 012.0244-4.6967A6.7935 6.7935 0 0010.0093 18C5.0425 18.0466 4 24.5513 4 30H2C2 18.4907 6.3452 16.0342 9.9907 16a10.0717 10.0717 0 014.4785 1.117 1 1 0 01.0616 1.73A4.8773 4.8773 0 0017 28h5zM17 8H19V16H17z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M28,5.4141,26.5859,4,24.3242,6.2617A9.95,9.95,0,0,0,19,4.0508V2H17V4.0508A10.0132,10.0132,0,0,0,8,14h2a8,8,0,1,1,8,8v2A9.9928,9.9928,0,0,0,25.7383,7.6758Z"
  })), children);
});
var WavePeriod20 = /*#__PURE__*/React.forwardRef(function WavePeriod20(_ref155, ref) {
  var children = _ref155.children,
      rest = _objectWithoutProperties(_ref155, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30H17a7.0078 7.0078 0 01-7-7 6.6832 6.6832 0 012.0244-4.6967A6.7935 6.7935 0 0010.0093 18C5.0425 18.0466 4 24.5513 4 30H2C2 18.4907 6.3452 16.0342 9.9907 16a10.0717 10.0717 0 014.4785 1.117 1 1 0 01.0616 1.73A4.8773 4.8773 0 0017 28h5zM17 8H19V16H17z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M28,5.4141,26.5859,4,24.3242,6.2617A9.95,9.95,0,0,0,19,4.0508V2H17V4.0508A10.0132,10.0132,0,0,0,8,14h2a8,8,0,1,1,8,8v2A9.9928,9.9928,0,0,0,25.7383,7.6758Z"
  })), children);
});
var WavePeriod16 = /*#__PURE__*/React.forwardRef(function WavePeriod16(_ref156, ref) {
  var children = _ref156.children,
      rest = _objectWithoutProperties(_ref156, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30H17a7.0078 7.0078 0 01-7-7 6.6832 6.6832 0 012.0244-4.6967A6.7935 6.7935 0 0010.0093 18C5.0425 18.0466 4 24.5513 4 30H2C2 18.4907 6.3452 16.0342 9.9907 16a10.0717 10.0717 0 014.4785 1.117 1 1 0 01.0616 1.73A4.8773 4.8773 0 0017 28h5zM17 8H19V16H17z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M28,5.4141,26.5859,4,24.3242,6.2617A9.95,9.95,0,0,0,19,4.0508V2H17V4.0508A10.0132,10.0132,0,0,0,8,14h2a8,8,0,1,1,8,8v2A9.9928,9.9928,0,0,0,25.7383,7.6758Z"
  })), children);
});
var WeatherFrontCold32 = /*#__PURE__*/React.forwardRef(function WeatherFrontCold32(_ref157, ref) {
  var children = _ref157.children,
      rest = _objectWithoutProperties(_ref157, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1655 2a13.0289 13.0289 0 00-12.542 9.5791l-1.1767 4.3154A11.0237 11.0237 0 013.8345 24H2v2H3.8345c.2975 0 .5918-.0171.8853-.0371l7.9291 2.9736A1 1 0 0014 28V21.0923a12.9311 12.9311 0 00.9121-1.313l6.3628-1.8179a1 1 0 00.5059-1.5864L17.7843 11.38a10.9268 10.9268 0 011.1516-2.3472l5.7477 1.916A1 1 0 0026 10V4.2251A10.8956 10.8956 0 0128.1655 4H30V2zM8.3354 25.1826A13.047 13.047 0 0012 23.0943v3.4624zm7.74-7.8154c.1107-.3105.2136-.625.3013-.9463l.732-2.6846L19.28 16.4512zM24 8.6123l-3.7411-1.247A11.0712 11.0712 0 0124 4.8306zM10 4L10 8.586 3.414 2 2 3.414 8.586 10 4 10 4 12 12 12 12 4 10 4z"
  })), children);
});
var WeatherFrontCold24 = /*#__PURE__*/React.forwardRef(function WeatherFrontCold24(_ref158, ref) {
  var children = _ref158.children,
      rest = _objectWithoutProperties(_ref158, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1655 2a13.0289 13.0289 0 00-12.542 9.5791l-1.1767 4.3154A11.0237 11.0237 0 013.8345 24H2v2H3.8345c.2975 0 .5918-.0171.8853-.0371l7.9291 2.9736A1 1 0 0014 28V21.0923a12.9311 12.9311 0 00.9121-1.313l6.3628-1.8179a1 1 0 00.5059-1.5864L17.7843 11.38a10.9268 10.9268 0 011.1516-2.3472l5.7477 1.916A1 1 0 0026 10V4.2251A10.8956 10.8956 0 0128.1655 4H30V2zM8.3354 25.1826A13.047 13.047 0 0012 23.0943v3.4624zm7.74-7.8154c.1107-.3105.2136-.625.3013-.9463l.732-2.6846L19.28 16.4512zM24 8.6123l-3.7411-1.247A11.0712 11.0712 0 0124 4.8306zM10 4L10 8.586 3.414 2 2 3.414 8.586 10 4 10 4 12 12 12 12 4 10 4z"
  })), children);
});
var WeatherFrontCold20 = /*#__PURE__*/React.forwardRef(function WeatherFrontCold20(_ref159, ref) {
  var children = _ref159.children,
      rest = _objectWithoutProperties(_ref159, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1655 2a13.0289 13.0289 0 00-12.542 9.5791l-1.1767 4.3154A11.0237 11.0237 0 013.8345 24H2v2H3.8345c.2975 0 .5918-.0171.8853-.0371l7.9291 2.9736A1 1 0 0014 28V21.0923a12.9311 12.9311 0 00.9121-1.313l6.3628-1.8179a1 1 0 00.5059-1.5864L17.7843 11.38a10.9268 10.9268 0 011.1516-2.3472l5.7477 1.916A1 1 0 0026 10V4.2251A10.8956 10.8956 0 0128.1655 4H30V2zM8.3354 25.1826A13.047 13.047 0 0012 23.0943v3.4624zm7.74-7.8154c.1107-.3105.2136-.625.3013-.9463l.732-2.6846L19.28 16.4512zM24 8.6123l-3.7411-1.247A11.0712 11.0712 0 0124 4.8306zM10 4L10 8.586 3.414 2 2 3.414 8.586 10 4 10 4 12 12 12 12 4 10 4z"
  })), children);
});
var WeatherFrontCold16 = /*#__PURE__*/React.forwardRef(function WeatherFrontCold16(_ref160, ref) {
  var children = _ref160.children,
      rest = _objectWithoutProperties(_ref160, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1655 2a13.0289 13.0289 0 00-12.542 9.5791l-1.1767 4.3154A11.0237 11.0237 0 013.8345 24H2v2H3.8345c.2975 0 .5918-.0171.8853-.0371l7.9291 2.9736A1 1 0 0014 28V21.0923a12.9311 12.9311 0 00.9121-1.313l6.3628-1.8179a1 1 0 00.5059-1.5864L17.7843 11.38a10.9268 10.9268 0 011.1516-2.3472l5.7477 1.916A1 1 0 0026 10V4.2251A10.8956 10.8956 0 0128.1655 4H30V2zM8.3354 25.1826A13.047 13.047 0 0012 23.0943v3.4624zm7.74-7.8154c.1107-.3105.2136-.625.3013-.9463l.732-2.6846L19.28 16.4512zM24 8.6123l-3.7411-1.247A11.0712 11.0712 0 0124 4.8306zM10 4L10 8.586 3.414 2 2 3.414 8.586 10 4 10 4 12 12 12 12 4 10 4z"
  })), children);
});
var WeatherFrontStationary32 = /*#__PURE__*/React.forwardRef(function WeatherFrontStationary32(_ref161, ref) {
  var children = _ref161.children,
      rest = _objectWithoutProperties(_ref161, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1655 2a12.9848 12.9848 0 00-8.4074 3.1065A3.9947 3.9947 0 1015.583 11.728l-1.1362 4.1665c-.0725.2657-.1579.5254-.2489.7818a3.9864 3.9864 0 00-5.1547 6.0054A10.9541 10.9541 0 013.8345 24H2v2H3.8345c.2975 0 .5918-.0171.8853-.0371l7.9291 2.9736A1 1 0 0014 28V21.0923a12.9311 12.9311 0 00.9121-1.313l6.3628-1.8179a1 1 0 00.5059-1.5864L17.7843 11.38a10.9268 10.9268 0 011.1516-2.3472l5.7477 1.916A1 1 0 0026 10V4.2251A10.8956 10.8956 0 0128.1655 4H30V2zM17 6a1.98 1.98 0 011.3237.53A12.9413 12.9413 0 0016.24 9.8482 1.9988 1.9988 0 0117 6zM10 20a1.9879 1.9879 0 013.3374-1.4717 11.0157 11.0157 0 01-2.5959 3.0147A1.9975 1.9975 0 0110 20zM8.3354 25.1826A13.047 13.047 0 0012 23.0943v3.4624zm7.74-7.8154c.1107-.3105.2136-.625.3013-.9463l.732-2.6846L19.28 16.4512zM24 8.6123l-3.7411-1.247A11.0712 11.0712 0 0124 4.8306zM22 22L22 24 26.586 24 22 28.586 23.414 30 28 25.414 28 30 30 30 30 22 22 22zM2 2L2 4 6.586 4 2 8.586 3.414 10 8 5.414 8 10 10 10 10 2 2 2z"
  })), children);
});
var WeatherFrontStationary24 = /*#__PURE__*/React.forwardRef(function WeatherFrontStationary24(_ref162, ref) {
  var children = _ref162.children,
      rest = _objectWithoutProperties(_ref162, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1655 2a12.9848 12.9848 0 00-8.4074 3.1065A3.9947 3.9947 0 1015.583 11.728l-1.1362 4.1665c-.0725.2657-.1579.5254-.2489.7818a3.9864 3.9864 0 00-5.1547 6.0054A10.9541 10.9541 0 013.8345 24H2v2H3.8345c.2975 0 .5918-.0171.8853-.0371l7.9291 2.9736A1 1 0 0014 28V21.0923a12.9311 12.9311 0 00.9121-1.313l6.3628-1.8179a1 1 0 00.5059-1.5864L17.7843 11.38a10.9268 10.9268 0 011.1516-2.3472l5.7477 1.916A1 1 0 0026 10V4.2251A10.8956 10.8956 0 0128.1655 4H30V2zM17 6a1.98 1.98 0 011.3237.53A12.9413 12.9413 0 0016.24 9.8482 1.9988 1.9988 0 0117 6zM10 20a1.9879 1.9879 0 013.3374-1.4717 11.0157 11.0157 0 01-2.5959 3.0147A1.9975 1.9975 0 0110 20zM8.3354 25.1826A13.047 13.047 0 0012 23.0943v3.4624zm7.74-7.8154c.1107-.3105.2136-.625.3013-.9463l.732-2.6846L19.28 16.4512zM24 8.6123l-3.7411-1.247A11.0712 11.0712 0 0124 4.8306zM22 22L22 24 26.586 24 22 28.586 23.414 30 28 25.414 28 30 30 30 30 22 22 22zM2 2L2 4 6.586 4 2 8.586 3.414 10 8 5.414 8 10 10 10 10 2 2 2z"
  })), children);
});
var WeatherFrontStationary20 = /*#__PURE__*/React.forwardRef(function WeatherFrontStationary20(_ref163, ref) {
  var children = _ref163.children,
      rest = _objectWithoutProperties(_ref163, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1655 2a12.9848 12.9848 0 00-8.4074 3.1065A3.9947 3.9947 0 1015.583 11.728l-1.1362 4.1665c-.0725.2657-.1579.5254-.2489.7818a3.9864 3.9864 0 00-5.1547 6.0054A10.9541 10.9541 0 013.8345 24H2v2H3.8345c.2975 0 .5918-.0171.8853-.0371l7.9291 2.9736A1 1 0 0014 28V21.0923a12.9311 12.9311 0 00.9121-1.313l6.3628-1.8179a1 1 0 00.5059-1.5864L17.7843 11.38a10.9268 10.9268 0 011.1516-2.3472l5.7477 1.916A1 1 0 0026 10V4.2251A10.8956 10.8956 0 0128.1655 4H30V2zM17 6a1.98 1.98 0 011.3237.53A12.9413 12.9413 0 0016.24 9.8482 1.9988 1.9988 0 0117 6zM10 20a1.9879 1.9879 0 013.3374-1.4717 11.0157 11.0157 0 01-2.5959 3.0147A1.9975 1.9975 0 0110 20zM8.3354 25.1826A13.047 13.047 0 0012 23.0943v3.4624zm7.74-7.8154c.1107-.3105.2136-.625.3013-.9463l.732-2.6846L19.28 16.4512zM24 8.6123l-3.7411-1.247A11.0712 11.0712 0 0124 4.8306zM22 22L22 24 26.586 24 22 28.586 23.414 30 28 25.414 28 30 30 30 30 22 22 22zM2 2L2 4 6.586 4 2 8.586 3.414 10 8 5.414 8 10 10 10 10 2 2 2z"
  })), children);
});
var WeatherFrontStationary16 = /*#__PURE__*/React.forwardRef(function WeatherFrontStationary16(_ref164, ref) {
  var children = _ref164.children,
      rest = _objectWithoutProperties(_ref164, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1655 2a12.9848 12.9848 0 00-8.4074 3.1065A3.9947 3.9947 0 1015.583 11.728l-1.1362 4.1665c-.0725.2657-.1579.5254-.2489.7818a3.9864 3.9864 0 00-5.1547 6.0054A10.9541 10.9541 0 013.8345 24H2v2H3.8345c.2975 0 .5918-.0171.8853-.0371l7.9291 2.9736A1 1 0 0014 28V21.0923a12.9311 12.9311 0 00.9121-1.313l6.3628-1.8179a1 1 0 00.5059-1.5864L17.7843 11.38a10.9268 10.9268 0 011.1516-2.3472l5.7477 1.916A1 1 0 0026 10V4.2251A10.8956 10.8956 0 0128.1655 4H30V2zM17 6a1.98 1.98 0 011.3237.53A12.9413 12.9413 0 0016.24 9.8482 1.9988 1.9988 0 0117 6zM10 20a1.9879 1.9879 0 013.3374-1.4717 11.0157 11.0157 0 01-2.5959 3.0147A1.9975 1.9975 0 0110 20zM8.3354 25.1826A13.047 13.047 0 0012 23.0943v3.4624zm7.74-7.8154c.1107-.3105.2136-.625.3013-.9463l.732-2.6846L19.28 16.4512zM24 8.6123l-3.7411-1.247A11.0712 11.0712 0 0124 4.8306zM22 22L22 24 26.586 24 22 28.586 23.414 30 28 25.414 28 30 30 30 30 22 22 22zM2 2L2 4 6.586 4 2 8.586 3.414 10 8 5.414 8 10 10 10 10 2 2 2z"
  })), children);
});
var WeatherFrontWarm32 = /*#__PURE__*/React.forwardRef(function WeatherFrontWarm32(_ref165, ref) {
  var children = _ref165.children,
      rest = _objectWithoutProperties(_ref165, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1655 2a13.0289 13.0289 0 00-12.542 9.5791l-1.1767 4.3154A11.0237 11.0237 0 013.8345 24H2v2H3.8345a12.9139 12.9139 0 003.4687-.4819 3.9979 3.9979 0 106.5818-4.2866 12.9671 12.9671 0 001.6209-2.5269 3.9944 3.9944 0 102.3772-7.5991 10.95 10.95 0 011.7253-3.01 3.9825 3.9825 0 006.9058-3.9648A10.9435 10.9435 0 0128.1655 4H30V2zM11 26a1.9983 1.9983 0 01-1.8118-1.1655 13.0811 13.0811 0 003.2969-2.1426A1.9773 1.9773 0 0111 26zm8-11a1.9926 1.9926 0 01-2.759 1.8467c.0442-.1426.0959-.2813.1355-.4258L17.301 13.03A1.9976 1.9976 0 0119 15zm6-9a1.9942 1.9942 0 01-3.9011.5894 11.0511 11.0511 0 013.3623-1.9385A1.995 1.995 0 0125 6zM10 4L10 8.586 3.414 2 2 3.414 8.586 10 4 10 4 12 12 12 12 4 10 4z"
  })), children);
});
var WeatherFrontWarm24 = /*#__PURE__*/React.forwardRef(function WeatherFrontWarm24(_ref166, ref) {
  var children = _ref166.children,
      rest = _objectWithoutProperties(_ref166, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1655 2a13.0289 13.0289 0 00-12.542 9.5791l-1.1767 4.3154A11.0237 11.0237 0 013.8345 24H2v2H3.8345a12.9139 12.9139 0 003.4687-.4819 3.9979 3.9979 0 106.5818-4.2866 12.9671 12.9671 0 001.6209-2.5269 3.9944 3.9944 0 102.3772-7.5991 10.95 10.95 0 011.7253-3.01 3.9825 3.9825 0 006.9058-3.9648A10.9435 10.9435 0 0128.1655 4H30V2zM11 26a1.9983 1.9983 0 01-1.8118-1.1655 13.0811 13.0811 0 003.2969-2.1426A1.9773 1.9773 0 0111 26zm8-11a1.9926 1.9926 0 01-2.759 1.8467c.0442-.1426.0959-.2813.1355-.4258L17.301 13.03A1.9976 1.9976 0 0119 15zm6-9a1.9942 1.9942 0 01-3.9011.5894 11.0511 11.0511 0 013.3623-1.9385A1.995 1.995 0 0125 6zM10 4L10 8.586 3.414 2 2 3.414 8.586 10 4 10 4 12 12 12 12 4 10 4z"
  })), children);
});
var WeatherFrontWarm20 = /*#__PURE__*/React.forwardRef(function WeatherFrontWarm20(_ref167, ref) {
  var children = _ref167.children,
      rest = _objectWithoutProperties(_ref167, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1655 2a13.0289 13.0289 0 00-12.542 9.5791l-1.1767 4.3154A11.0237 11.0237 0 013.8345 24H2v2H3.8345a12.9139 12.9139 0 003.4687-.4819 3.9979 3.9979 0 106.5818-4.2866 12.9671 12.9671 0 001.6209-2.5269 3.9944 3.9944 0 102.3772-7.5991 10.95 10.95 0 011.7253-3.01 3.9825 3.9825 0 006.9058-3.9648A10.9435 10.9435 0 0128.1655 4H30V2zM11 26a1.9983 1.9983 0 01-1.8118-1.1655 13.0811 13.0811 0 003.2969-2.1426A1.9773 1.9773 0 0111 26zm8-11a1.9926 1.9926 0 01-2.759 1.8467c.0442-.1426.0959-.2813.1355-.4258L17.301 13.03A1.9976 1.9976 0 0119 15zm6-9a1.9942 1.9942 0 01-3.9011.5894 11.0511 11.0511 0 013.3623-1.9385A1.995 1.995 0 0125 6zM10 4L10 8.586 3.414 2 2 3.414 8.586 10 4 10 4 12 12 12 12 4 10 4z"
  })), children);
});
var WeatherFrontWarm16 = /*#__PURE__*/React.forwardRef(function WeatherFrontWarm16(_ref168, ref) {
  var children = _ref168.children,
      rest = _objectWithoutProperties(_ref168, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1655 2a13.0289 13.0289 0 00-12.542 9.5791l-1.1767 4.3154A11.0237 11.0237 0 013.8345 24H2v2H3.8345a12.9139 12.9139 0 003.4687-.4819 3.9979 3.9979 0 106.5818-4.2866 12.9671 12.9671 0 001.6209-2.5269 3.9944 3.9944 0 102.3772-7.5991 10.95 10.95 0 011.7253-3.01 3.9825 3.9825 0 006.9058-3.9648A10.9435 10.9435 0 0128.1655 4H30V2zM11 26a1.9983 1.9983 0 01-1.8118-1.1655 13.0811 13.0811 0 003.2969-2.1426A1.9773 1.9773 0 0111 26zm8-11a1.9926 1.9926 0 01-2.759 1.8467c.0442-.1426.0959-.2813.1355-.4258L17.301 13.03A1.9976 1.9976 0 0119 15zm6-9a1.9942 1.9942 0 01-3.9011.5894 11.0511 11.0511 0 013.3623-1.9385A1.995 1.995 0 0125 6zM10 4L10 8.586 3.414 2 2 3.414 8.586 10 4 10 4 12 12 12 12 4 10 4z"
  })), children);
});
var WeatherStation32 = /*#__PURE__*/React.forwardRef(function WeatherStation32(_ref169, ref) {
  var children = _ref169.children,
      rest = _objectWithoutProperties(_ref169, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M17,28V17h1a2.0023,2.0023,0,0,0,2-2V11a2.0023,2.0023,0,0,0-2-2H14a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2h1V28H2v2H30V28ZM14,11h4l.0015,4H14Z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3325 18.2168a7.0007 7.0007 0 010-10.4341l1.334 1.49a5 5 0 000 7.4537zM22.667 18.2168l-1.334-1.49a4.9995 4.9995 0 000-7.4537l1.334-1.49a7 7 0 010 10.4341z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3994 21.8008a11.0019 11.0019 0 010-17.6006L7.6 5.8a9.0009 9.0009 0 000 14.4014zM25.6006 21.8008l-1.2012-1.6a9.001 9.001 0 000-14.4019l1.2012-1.6a11.002 11.002 0 010 17.6011z"
  })), children);
});
var WeatherStation24 = /*#__PURE__*/React.forwardRef(function WeatherStation24(_ref170, ref) {
  var children = _ref170.children,
      rest = _objectWithoutProperties(_ref170, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M17,28V17h1a2.0023,2.0023,0,0,0,2-2V11a2.0023,2.0023,0,0,0-2-2H14a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2h1V28H2v2H30V28ZM14,11h4l.0015,4H14Z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3325 18.2168a7.0007 7.0007 0 010-10.4341l1.334 1.49a5 5 0 000 7.4537zM22.667 18.2168l-1.334-1.49a4.9995 4.9995 0 000-7.4537l1.334-1.49a7 7 0 010 10.4341z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3994 21.8008a11.0019 11.0019 0 010-17.6006L7.6 5.8a9.0009 9.0009 0 000 14.4014zM25.6006 21.8008l-1.2012-1.6a9.001 9.001 0 000-14.4019l1.2012-1.6a11.002 11.002 0 010 17.6011z"
  })), children);
});
var WeatherStation20 = /*#__PURE__*/React.forwardRef(function WeatherStation20(_ref171, ref) {
  var children = _ref171.children,
      rest = _objectWithoutProperties(_ref171, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M17,28V17h1a2.0023,2.0023,0,0,0,2-2V11a2.0023,2.0023,0,0,0-2-2H14a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2h1V28H2v2H30V28ZM14,11h4l.0015,4H14Z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3325 18.2168a7.0007 7.0007 0 010-10.4341l1.334 1.49a5 5 0 000 7.4537zM22.667 18.2168l-1.334-1.49a4.9995 4.9995 0 000-7.4537l1.334-1.49a7 7 0 010 10.4341z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3994 21.8008a11.0019 11.0019 0 010-17.6006L7.6 5.8a9.0009 9.0009 0 000 14.4014zM25.6006 21.8008l-1.2012-1.6a9.001 9.001 0 000-14.4019l1.2012-1.6a11.002 11.002 0 010 17.6011z"
  })), children);
});
var WeatherStation16 = /*#__PURE__*/React.forwardRef(function WeatherStation16(_ref172, ref) {
  var children = _ref172.children,
      rest = _objectWithoutProperties(_ref172, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M17,28V17h1a2.0023,2.0023,0,0,0,2-2V11a2.0023,2.0023,0,0,0-2-2H14a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2h1V28H2v2H30V28ZM14,11h4l.0015,4H14Z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3325 18.2168a7.0007 7.0007 0 010-10.4341l1.334 1.49a5 5 0 000 7.4537zM22.667 18.2168l-1.334-1.49a4.9995 4.9995 0 000-7.4537l1.334-1.49a7 7 0 010 10.4341z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3994 21.8008a11.0019 11.0019 0 010-17.6006L7.6 5.8a9.0009 9.0009 0 000 14.4014zM25.6006 21.8008l-1.2012-1.6a9.001 9.001 0 000-14.4019l1.2012-1.6a11.002 11.002 0 010 17.6011z"
  })), children);
});
var Websheet32 = /*#__PURE__*/React.forwardRef(function Websheet32(_ref173, ref) {
  var children = _ref173.children,
      rest = _objectWithoutProperties(_ref173, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: "2"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,24,30Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,24,20Z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
  })), children);
});
var Websheet24 = /*#__PURE__*/React.forwardRef(function Websheet24(_ref174, ref) {
  var children = _ref174.children,
      rest = _objectWithoutProperties(_ref174, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: "2"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,24,30Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,24,20Z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
  })), children);
});
var Websheet20 = /*#__PURE__*/React.forwardRef(function Websheet20(_ref175, ref) {
  var children = _ref175.children,
      rest = _objectWithoutProperties(_ref175, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: "2"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,24,30Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,24,20Z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
  })), children);
});
var Websheet16 = /*#__PURE__*/React.forwardRef(function Websheet16(_ref176, ref) {
  var children = _ref176.children,
      rest = _objectWithoutProperties(_ref176, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: "2"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,24,30Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,24,20Z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
  })), children);
});
var Wheat32 = /*#__PURE__*/React.forwardRef(function Wheat32(_ref177, ref) {
  var children = _ref177.children,
      rest = _objectWithoutProperties(_ref177, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M21,3V5.5857l-4,4V1H15V9.5857l-4-4V3H9V19a7.004,7.004,0,0,0,6,6.92V30h2V25.92A7.004,7.004,0,0,0,23,19V3ZM15,23.8987A5.008,5.008,0,0,1,11,19v-2.586l4,4Zm0-6.313-4-4V8.4138l4,4Zm2-5.1719,4-4v5.1719l-4,4Zm0,11.4849V20.4138l4-4V19A5.008,5.008,0,0,1,17,23.8987Z"
  })), children);
});
var Wheat24 = /*#__PURE__*/React.forwardRef(function Wheat24(_ref178, ref) {
  var children = _ref178.children,
      rest = _objectWithoutProperties(_ref178, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M21,3V5.5857l-4,4V1H15V9.5857l-4-4V3H9V19a7.004,7.004,0,0,0,6,6.92V30h2V25.92A7.004,7.004,0,0,0,23,19V3ZM15,23.8987A5.008,5.008,0,0,1,11,19v-2.586l4,4Zm0-6.313-4-4V8.4138l4,4Zm2-5.1719,4-4v5.1719l-4,4Zm0,11.4849V20.4138l4-4V19A5.008,5.008,0,0,1,17,23.8987Z"
  })), children);
});
var Wheat20 = /*#__PURE__*/React.forwardRef(function Wheat20(_ref179, ref) {
  var children = _ref179.children,
      rest = _objectWithoutProperties(_ref179, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M21,3V5.5857l-4,4V1H15V9.5857l-4-4V3H9V19a7.004,7.004,0,0,0,6,6.92V30h2V25.92A7.004,7.004,0,0,0,23,19V3ZM15,23.8987A5.008,5.008,0,0,1,11,19v-2.586l4,4Zm0-6.313-4-4V8.4138l4,4Zm2-5.1719,4-4v5.1719l-4,4Zm0,11.4849V20.4138l4-4V19A5.008,5.008,0,0,1,17,23.8987Z"
  })), children);
});
var Wheat16 = /*#__PURE__*/React.forwardRef(function Wheat16(_ref180, ref) {
  var children = _ref180.children,
      rest = _objectWithoutProperties(_ref180, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M21,3V5.5857l-4,4V1H15V9.5857l-4-4V3H9V19a7.004,7.004,0,0,0,6,6.92V30h2V25.92A7.004,7.004,0,0,0,23,19V3ZM15,23.8987A5.008,5.008,0,0,1,11,19v-2.586l4,4Zm0-6.313-4-4V8.4138l4,4Zm2-5.1719,4-4v5.1719l-4,4Zm0,11.4849V20.4138l4-4V19A5.008,5.008,0,0,1,17,23.8987Z"
  })), children);
});
var Wifi32 = /*#__PURE__*/React.forwardRef(function Wifi32(_ref181, ref) {
  var children = _ref181.children,
      rest = _objectWithoutProperties(_ref181, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "25",
    r: "2"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M10.47,19.2334l1.4136,1.4131a5.9688,5.9688,0,0,1,8.2229-.0093L21.52,19.2236a7.9629,7.9629,0,0,0-11.05.01Z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M6.229,14.9927l1.4136,1.4135a11.955,11.955,0,0,1,16.7041-.01L25.76,14.9829a13.9514,13.9514,0,0,0-19.5313.01Z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10.7412a19.94,19.94,0,0,0-28,0v.0225L3.4043,12.168a17.9336,17.9336,0,0,1,25.1811-.01L30,10.7432Z"
  })), children);
});
var Wifi24 = /*#__PURE__*/React.forwardRef(function Wifi24(_ref182, ref) {
  var children = _ref182.children,
      rest = _objectWithoutProperties(_ref182, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "25",
    r: "2"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M10.47,19.2334l1.4136,1.4131a5.9688,5.9688,0,0,1,8.2229-.0093L21.52,19.2236a7.9629,7.9629,0,0,0-11.05.01Z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M6.229,14.9927l1.4136,1.4135a11.955,11.955,0,0,1,16.7041-.01L25.76,14.9829a13.9514,13.9514,0,0,0-19.5313.01Z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10.7412a19.94,19.94,0,0,0-28,0v.0225L3.4043,12.168a17.9336,17.9336,0,0,1,25.1811-.01L30,10.7432Z"
  })), children);
});
var Wifi20 = /*#__PURE__*/React.forwardRef(function Wifi20(_ref183, ref) {
  var children = _ref183.children,
      rest = _objectWithoutProperties(_ref183, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "25",
    r: "2"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M10.47,19.2334l1.4136,1.4131a5.9688,5.9688,0,0,1,8.2229-.0093L21.52,19.2236a7.9629,7.9629,0,0,0-11.05.01Z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M6.229,14.9927l1.4136,1.4135a11.955,11.955,0,0,1,16.7041-.01L25.76,14.9829a13.9514,13.9514,0,0,0-19.5313.01Z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10.7412a19.94,19.94,0,0,0-28,0v.0225L3.4043,12.168a17.9336,17.9336,0,0,1,25.1811-.01L30,10.7432Z"
  })), children);
});
var Wifi16 = /*#__PURE__*/React.forwardRef(function Wifi16(_ref184, ref) {
  var children = _ref184.children,
      rest = _objectWithoutProperties(_ref184, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "25",
    r: "2"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M10.47,19.2334l1.4136,1.4131a5.9688,5.9688,0,0,1,8.2229-.0093L21.52,19.2236a7.9629,7.9629,0,0,0-11.05.01Z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M6.229,14.9927l1.4136,1.4135a11.955,11.955,0,0,1,16.7041-.01L25.76,14.9829a13.9514,13.9514,0,0,0-19.5313.01Z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10.7412a19.94,19.94,0,0,0-28,0v.0225L3.4043,12.168a17.9336,17.9336,0,0,1,25.1811-.01L30,10.7432Z"
  })), children);
});
var WifiOff32 = /*#__PURE__*/React.forwardRef(function WifiOff32(_ref185, ref) {
  var children = _ref185.children,
      rest = _objectWithoutProperties(_ref185, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "25",
    r: "2"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M30 3.4141L28.5859 2 2 28.5859 3.4141 30 14.0962 19.3179a5.9359 5.9359 0 016.01 1.3193L21.52 19.2236a7.9669 7.9669 0 00-5.125-2.2041l3.3875-3.3877a11.9908 11.9908 0 014.5647 2.7647L25.76 14.9829A13.975 13.975 0 0021.334 12.08L24.3308 9.083a17.9364 17.9364 0 014.2546 3.0747L30 10.7432v-.002a20.02 20.02 0 00-4.1895-3.1377zM14.68 13.0776l2.0415-2.0415C16.481 11.0234 16.2437 11 16 11a13.9447 13.9447 0 00-9.771 3.9927l1.4136 1.4136A11.97 11.97 0 0114.68 13.0776zM16 7a17.87 17.87 0 014.2324.5254L21.875 5.8828A19.9537 19.9537 0 002 10.7412v.0225L3.4043 12.168A17.9193 17.9193 0 0116 7z"
  })), children);
});
var WifiOff24 = /*#__PURE__*/React.forwardRef(function WifiOff24(_ref186, ref) {
  var children = _ref186.children,
      rest = _objectWithoutProperties(_ref186, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "25",
    r: "2"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M30 3.4141L28.5859 2 2 28.5859 3.4141 30 14.0962 19.3179a5.9359 5.9359 0 016.01 1.3193L21.52 19.2236a7.9669 7.9669 0 00-5.125-2.2041l3.3875-3.3877a11.9908 11.9908 0 014.5647 2.7647L25.76 14.9829A13.975 13.975 0 0021.334 12.08L24.3308 9.083a17.9364 17.9364 0 014.2546 3.0747L30 10.7432v-.002a20.02 20.02 0 00-4.1895-3.1377zM14.68 13.0776l2.0415-2.0415C16.481 11.0234 16.2437 11 16 11a13.9447 13.9447 0 00-9.771 3.9927l1.4136 1.4136A11.97 11.97 0 0114.68 13.0776zM16 7a17.87 17.87 0 014.2324.5254L21.875 5.8828A19.9537 19.9537 0 002 10.7412v.0225L3.4043 12.168A17.9193 17.9193 0 0116 7z"
  })), children);
});
var WifiOff20 = /*#__PURE__*/React.forwardRef(function WifiOff20(_ref187, ref) {
  var children = _ref187.children,
      rest = _objectWithoutProperties(_ref187, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "25",
    r: "2"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M30 3.4141L28.5859 2 2 28.5859 3.4141 30 14.0962 19.3179a5.9359 5.9359 0 016.01 1.3193L21.52 19.2236a7.9669 7.9669 0 00-5.125-2.2041l3.3875-3.3877a11.9908 11.9908 0 014.5647 2.7647L25.76 14.9829A13.975 13.975 0 0021.334 12.08L24.3308 9.083a17.9364 17.9364 0 014.2546 3.0747L30 10.7432v-.002a20.02 20.02 0 00-4.1895-3.1377zM14.68 13.0776l2.0415-2.0415C16.481 11.0234 16.2437 11 16 11a13.9447 13.9447 0 00-9.771 3.9927l1.4136 1.4136A11.97 11.97 0 0114.68 13.0776zM16 7a17.87 17.87 0 014.2324.5254L21.875 5.8828A19.9537 19.9537 0 002 10.7412v.0225L3.4043 12.168A17.9193 17.9193 0 0116 7z"
  })), children);
});
var WifiOff16 = /*#__PURE__*/React.forwardRef(function WifiOff16(_ref188, ref) {
  var children = _ref188.children,
      rest = _objectWithoutProperties(_ref188, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "25",
    r: "2"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M30 3.4141L28.5859 2 2 28.5859 3.4141 30 14.0962 19.3179a5.9359 5.9359 0 016.01 1.3193L21.52 19.2236a7.9669 7.9669 0 00-5.125-2.2041l3.3875-3.3877a11.9908 11.9908 0 014.5647 2.7647L25.76 14.9829A13.975 13.975 0 0021.334 12.08L24.3308 9.083a17.9364 17.9364 0 014.2546 3.0747L30 10.7432v-.002a20.02 20.02 0 00-4.1895-3.1377zM14.68 13.0776l2.0415-2.0415C16.481 11.0234 16.2437 11 16 11a13.9447 13.9447 0 00-9.771 3.9927l1.4136 1.4136A11.97 11.97 0 0114.68 13.0776zM16 7a17.87 17.87 0 014.2324.5254L21.875 5.8828A19.9537 19.9537 0 002 10.7412v.0225L3.4043 12.168A17.9193 17.9193 0 0116 7z"
  })), children);
});
var Wikis32 = /*#__PURE__*/React.forwardRef(function Wikis32(_ref189, ref) {
  var children = _ref189.children,
      rest = _objectWithoutProperties(_ref189, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM28,15H22A24.26,24.26,0,0,0,19.21,4.45,12,12,0,0,1,28,15ZM16,28a5,5,0,0,1-.67,0A21.85,21.85,0,0,1,12,17H20a21.85,21.85,0,0,1-3.3,11A5,5,0,0,1,16,28ZM12,15a21.85,21.85,0,0,1,3.3-11,6,6,0,0,1,1.34,0A21.85,21.85,0,0,1,20,15Zm.76-10.55A24.26,24.26,0,0,0,10,15h-6A12,12,0,0,1,12.79,4.45ZM4.05,17h6a24.26,24.26,0,0,0,2.75,10.55A12,12,0,0,1,4.05,17ZM19.21,27.55A24.26,24.26,0,0,0,22,17h6A12,12,0,0,1,19.21,27.55Z"
  })), children);
});
var Wikis24 = /*#__PURE__*/React.forwardRef(function Wikis24(_ref190, ref) {
  var children = _ref190.children,
      rest = _objectWithoutProperties(_ref190, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM28,15H22A24.26,24.26,0,0,0,19.21,4.45,12,12,0,0,1,28,15ZM16,28a5,5,0,0,1-.67,0A21.85,21.85,0,0,1,12,17H20a21.85,21.85,0,0,1-3.3,11A5,5,0,0,1,16,28ZM12,15a21.85,21.85,0,0,1,3.3-11,6,6,0,0,1,1.34,0A21.85,21.85,0,0,1,20,15Zm.76-10.55A24.26,24.26,0,0,0,10,15h-6A12,12,0,0,1,12.79,4.45ZM4.05,17h6a24.26,24.26,0,0,0,2.75,10.55A12,12,0,0,1,4.05,17ZM19.21,27.55A24.26,24.26,0,0,0,22,17h6A12,12,0,0,1,19.21,27.55Z"
  })), children);
});
var Wikis20 = /*#__PURE__*/React.forwardRef(function Wikis20(_ref191, ref) {
  var children = _ref191.children,
      rest = _objectWithoutProperties(_ref191, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM28,15H22A24.26,24.26,0,0,0,19.21,4.45,12,12,0,0,1,28,15ZM16,28a5,5,0,0,1-.67,0A21.85,21.85,0,0,1,12,17H20a21.85,21.85,0,0,1-3.3,11A5,5,0,0,1,16,28ZM12,15a21.85,21.85,0,0,1,3.3-11,6,6,0,0,1,1.34,0A21.85,21.85,0,0,1,20,15Zm.76-10.55A24.26,24.26,0,0,0,10,15h-6A12,12,0,0,1,12.79,4.45ZM4.05,17h6a24.26,24.26,0,0,0,2.75,10.55A12,12,0,0,1,4.05,17ZM19.21,27.55A24.26,24.26,0,0,0,22,17h6A12,12,0,0,1,19.21,27.55Z"
  })), children);
});
var Wikis16 = /*#__PURE__*/React.forwardRef(function Wikis16(_ref192, ref) {
  var children = _ref192.children,
      rest = _objectWithoutProperties(_ref192, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM28,15H22A24.26,24.26,0,0,0,19.21,4.45,12,12,0,0,1,28,15ZM16,28a5,5,0,0,1-.67,0A21.85,21.85,0,0,1,12,17H20a21.85,21.85,0,0,1-3.3,11A5,5,0,0,1,16,28ZM12,15a21.85,21.85,0,0,1,3.3-11,6,6,0,0,1,1.34,0A21.85,21.85,0,0,1,20,15Zm.76-10.55A24.26,24.26,0,0,0,10,15h-6A12,12,0,0,1,12.79,4.45ZM4.05,17h6a24.26,24.26,0,0,0,2.75,10.55A12,12,0,0,1,4.05,17ZM19.21,27.55A24.26,24.26,0,0,0,22,17h6A12,12,0,0,1,19.21,27.55Z"
  })), children);
});
var WindGusts32 = /*#__PURE__*/React.forwardRef(function WindGusts32(_ref193, ref) {
  var children = _ref193.children,
      rest = _objectWithoutProperties(_ref193, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3164,8.0513l-18-6A1,1,0,0,0,10.4,2.2L4,7V2H2V30H4V11l6.4,4.8a1,1,0,0,0,.9165.1489l18-6a1,1,0,0,0,0-1.8974ZM10,13,4.6665,9,10,5Zm4-.0542-2,.667V4.3872l2,.667Zm4-1.333-2,.6665V5.7207l2,.6665Zm2-.667V7.0542L25.8379,9Z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M20,22a4,4,0,0,0-8,0h2a2,2,0,1,1,2,2H8v2h8A4.0045,4.0045,0,0,0,20,22Z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22a4.0045,4.0045,0,0,0-4,4h2a2,2,0,1,1,2,2H12v2H26a4,4,0,0,0,0-8Z"
  })), children);
});
var WindGusts24 = /*#__PURE__*/React.forwardRef(function WindGusts24(_ref194, ref) {
  var children = _ref194.children,
      rest = _objectWithoutProperties(_ref194, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3164,8.0513l-18-6A1,1,0,0,0,10.4,2.2L4,7V2H2V30H4V11l6.4,4.8a1,1,0,0,0,.9165.1489l18-6a1,1,0,0,0,0-1.8974ZM10,13,4.6665,9,10,5Zm4-.0542-2,.667V4.3872l2,.667Zm4-1.333-2,.6665V5.7207l2,.6665Zm2-.667V7.0542L25.8379,9Z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M20,22a4,4,0,0,0-8,0h2a2,2,0,1,1,2,2H8v2h8A4.0045,4.0045,0,0,0,20,22Z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22a4.0045,4.0045,0,0,0-4,4h2a2,2,0,1,1,2,2H12v2H26a4,4,0,0,0,0-8Z"
  })), children);
});
var WindGusts20 = /*#__PURE__*/React.forwardRef(function WindGusts20(_ref195, ref) {
  var children = _ref195.children,
      rest = _objectWithoutProperties(_ref195, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3164,8.0513l-18-6A1,1,0,0,0,10.4,2.2L4,7V2H2V30H4V11l6.4,4.8a1,1,0,0,0,.9165.1489l18-6a1,1,0,0,0,0-1.8974ZM10,13,4.6665,9,10,5Zm4-.0542-2,.667V4.3872l2,.667Zm4-1.333-2,.6665V5.7207l2,.6665Zm2-.667V7.0542L25.8379,9Z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M20,22a4,4,0,0,0-8,0h2a2,2,0,1,1,2,2H8v2h8A4.0045,4.0045,0,0,0,20,22Z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22a4.0045,4.0045,0,0,0-4,4h2a2,2,0,1,1,2,2H12v2H26a4,4,0,0,0,0-8Z"
  })), children);
});
var WindGusts16 = /*#__PURE__*/React.forwardRef(function WindGusts16(_ref196, ref) {
  var children = _ref196.children,
      rest = _objectWithoutProperties(_ref196, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3164,8.0513l-18-6A1,1,0,0,0,10.4,2.2L4,7V2H2V30H4V11l6.4,4.8a1,1,0,0,0,.9165.1489l18-6a1,1,0,0,0,0-1.8974ZM10,13,4.6665,9,10,5Zm4-.0542-2,.667V4.3872l2,.667Zm4-1.333-2,.6665V5.7207l2,.6665Zm2-.667V7.0542L25.8379,9Z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M20,22a4,4,0,0,0-8,0h2a2,2,0,1,1,2,2H8v2h8A4.0045,4.0045,0,0,0,20,22Z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22a4.0045,4.0045,0,0,0-4,4h2a2,2,0,1,1,2,2H12v2H26a4,4,0,0,0,0-8Z"
  })), children);
});
var WindStream32 = /*#__PURE__*/React.forwardRef(function WindStream32(_ref197, ref) {
  var children = _ref197.children,
      rest = _objectWithoutProperties(_ref197, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M25,2,23.5859,3.4141,26.1719,6h-5.09a16.93,16.93,0,0,0-6.3139,1.2158L10.4893,8.9272A14.93,14.93,0,0,1,4.9185,10H2v2H4.9185a16.93,16.93,0,0,0,6.3139-1.2158l4.2783-1.7114A14.93,14.93,0,0,1,21.0815,8h5.09l-2.586,2.5859L25,12l5-5Z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M21,11l-1.4141,1.4141L22.1719,15H18.9014a16.9422,16.9422,0,0,0-5.9693,1.0825l-2.5664.9624A14.9456,14.9456,0,0,1,5.0986,18H2v2H5.0986a16.9422,16.9422,0,0,0,5.9693-1.0825l2.5664-.9624A14.9456,14.9456,0,0,1,18.9014,17h3.2705l-2.586,2.5859L21,21l5-5Z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M17,20l-1.4141,1.4141L18.1719,24H16.5967a16.9879,16.9879,0,0,0-5.3765.8721l-1.0727.3584A14.9852,14.9852,0,0,1,5.4033,26H2v2H5.4033a16.9879,16.9879,0,0,0,5.3765-.8721l1.0727-.3584A14.9852,14.9852,0,0,1,16.5967,26h1.5752l-2.586,2.5859L17,30l5-5Z"
  })), children);
});
var WindStream24 = /*#__PURE__*/React.forwardRef(function WindStream24(_ref198, ref) {
  var children = _ref198.children,
      rest = _objectWithoutProperties(_ref198, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M25,2,23.5859,3.4141,26.1719,6h-5.09a16.93,16.93,0,0,0-6.3139,1.2158L10.4893,8.9272A14.93,14.93,0,0,1,4.9185,10H2v2H4.9185a16.93,16.93,0,0,0,6.3139-1.2158l4.2783-1.7114A14.93,14.93,0,0,1,21.0815,8h5.09l-2.586,2.5859L25,12l5-5Z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M21,11l-1.4141,1.4141L22.1719,15H18.9014a16.9422,16.9422,0,0,0-5.9693,1.0825l-2.5664.9624A14.9456,14.9456,0,0,1,5.0986,18H2v2H5.0986a16.9422,16.9422,0,0,0,5.9693-1.0825l2.5664-.9624A14.9456,14.9456,0,0,1,18.9014,17h3.2705l-2.586,2.5859L21,21l5-5Z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M17,20l-1.4141,1.4141L18.1719,24H16.5967a16.9879,16.9879,0,0,0-5.3765.8721l-1.0727.3584A14.9852,14.9852,0,0,1,5.4033,26H2v2H5.4033a16.9879,16.9879,0,0,0,5.3765-.8721l1.0727-.3584A14.9852,14.9852,0,0,1,16.5967,26h1.5752l-2.586,2.5859L17,30l5-5Z"
  })), children);
});
var WindStream20 = /*#__PURE__*/React.forwardRef(function WindStream20(_ref199, ref) {
  var children = _ref199.children,
      rest = _objectWithoutProperties(_ref199, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M25,2,23.5859,3.4141,26.1719,6h-5.09a16.93,16.93,0,0,0-6.3139,1.2158L10.4893,8.9272A14.93,14.93,0,0,1,4.9185,10H2v2H4.9185a16.93,16.93,0,0,0,6.3139-1.2158l4.2783-1.7114A14.93,14.93,0,0,1,21.0815,8h5.09l-2.586,2.5859L25,12l5-5Z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M21,11l-1.4141,1.4141L22.1719,15H18.9014a16.9422,16.9422,0,0,0-5.9693,1.0825l-2.5664.9624A14.9456,14.9456,0,0,1,5.0986,18H2v2H5.0986a16.9422,16.9422,0,0,0,5.9693-1.0825l2.5664-.9624A14.9456,14.9456,0,0,1,18.9014,17h3.2705l-2.586,2.5859L21,21l5-5Z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M17,20l-1.4141,1.4141L18.1719,24H16.5967a16.9879,16.9879,0,0,0-5.3765.8721l-1.0727.3584A14.9852,14.9852,0,0,1,5.4033,26H2v2H5.4033a16.9879,16.9879,0,0,0,5.3765-.8721l1.0727-.3584A14.9852,14.9852,0,0,1,16.5967,26h1.5752l-2.586,2.5859L17,30l5-5Z"
  })), children);
});
var WindStream16 = /*#__PURE__*/React.forwardRef(function WindStream16(_ref200, ref) {
  var children = _ref200.children,
      rest = _objectWithoutProperties(_ref200, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M25,2,23.5859,3.4141,26.1719,6h-5.09a16.93,16.93,0,0,0-6.3139,1.2158L10.4893,8.9272A14.93,14.93,0,0,1,4.9185,10H2v2H4.9185a16.93,16.93,0,0,0,6.3139-1.2158l4.2783-1.7114A14.93,14.93,0,0,1,21.0815,8h5.09l-2.586,2.5859L25,12l5-5Z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M21,11l-1.4141,1.4141L22.1719,15H18.9014a16.9422,16.9422,0,0,0-5.9693,1.0825l-2.5664.9624A14.9456,14.9456,0,0,1,5.0986,18H2v2H5.0986a16.9422,16.9422,0,0,0,5.9693-1.0825l2.5664-.9624A14.9456,14.9456,0,0,1,18.9014,17h3.2705l-2.586,2.5859L21,21l5-5Z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M17,20l-1.4141,1.4141L18.1719,24H16.5967a16.9879,16.9879,0,0,0-5.3765.8721l-1.0727.3584A14.9852,14.9852,0,0,1,5.4033,26H2v2H5.4033a16.9879,16.9879,0,0,0,5.3765-.8721l1.0727-.3584A14.9852,14.9852,0,0,1,16.5967,26h1.5752l-2.586,2.5859L17,30l5-5Z"
  })), children);
});
var WatsonHealthWindowAuto32 = /*#__PURE__*/React.forwardRef(function WatsonHealthWindowAuto32(_ref201, ref) {
  var children = _ref201.children,
      rest = _objectWithoutProperties(_ref201, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4H17V7H15zM25 15H28V17H25zM15 25H17V28H15zM4 15H7V17H4z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55 7.04H9.55V10.04H7.55z",
    transform: "rotate(-45 8.55 8.548)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M21.96 7.55H24.96V9.55H21.96z",
    transform: "rotate(-45 23.454 8.555)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M22.45 21.95H24.45V24.95H22.45z",
    transform: "rotate(-45 23.452 23.446)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05 22.45H10.05V24.45H7.05z",
    transform: "rotate(-45 8.544 23.451)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M4 30H28V32H4zM4 0H28V2H4zM16 10a6 6 0 106 6A6 6 0 0016 10zm-4 6a4 4 0 014-4v8A4 4 0 0112 16z"
  })), children);
});
var WatsonHealthWindowAuto24 = /*#__PURE__*/React.forwardRef(function WatsonHealthWindowAuto24(_ref202, ref) {
  var children = _ref202.children,
      rest = _objectWithoutProperties(_ref202, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4H17V7H15zM25 15H28V17H25zM15 25H17V28H15zM4 15H7V17H4z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55 7.04H9.55V10.04H7.55z",
    transform: "rotate(-45 8.55 8.548)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M21.96 7.55H24.96V9.55H21.96z",
    transform: "rotate(-45 23.454 8.555)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M22.45 21.95H24.45V24.95H22.45z",
    transform: "rotate(-45 23.452 23.446)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05 22.45H10.05V24.45H7.05z",
    transform: "rotate(-45 8.544 23.451)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M4 30H28V32H4zM4 0H28V2H4zM16 10a6 6 0 106 6A6 6 0 0016 10zm-4 6a4 4 0 014-4v8A4 4 0 0112 16z"
  })), children);
});
var WatsonHealthWindowAuto20 = /*#__PURE__*/React.forwardRef(function WatsonHealthWindowAuto20(_ref203, ref) {
  var children = _ref203.children,
      rest = _objectWithoutProperties(_ref203, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4H17V7H15zM25 15H28V17H25zM15 25H17V28H15zM4 15H7V17H4z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55 7.04H9.55V10.04H7.55z",
    transform: "rotate(-45 8.55 8.548)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M21.96 7.55H24.96V9.55H21.96z",
    transform: "rotate(-45 23.454 8.555)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M22.45 21.95H24.45V24.95H22.45z",
    transform: "rotate(-45 23.452 23.446)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05 22.45H10.05V24.45H7.05z",
    transform: "rotate(-45 8.544 23.451)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M4 30H28V32H4zM4 0H28V2H4zM16 10a6 6 0 106 6A6 6 0 0016 10zm-4 6a4 4 0 014-4v8A4 4 0 0112 16z"
  })), children);
});
var WatsonHealthWindowAuto16 = /*#__PURE__*/React.forwardRef(function WatsonHealthWindowAuto16(_ref204, ref) {
  var children = _ref204.children,
      rest = _objectWithoutProperties(_ref204, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4H17V7H15zM25 15H28V17H25zM15 25H17V28H15zM4 15H7V17H4z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55 7.04H9.55V10.04H7.55z",
    transform: "rotate(-45 8.55 8.548)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M21.96 7.55H24.96V9.55H21.96z",
    transform: "rotate(-45 23.454 8.555)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M22.45 21.95H24.45V24.95H22.45z",
    transform: "rotate(-45 23.452 23.446)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05 22.45H10.05V24.45H7.05z",
    transform: "rotate(-45 8.544 23.451)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M4 30H28V32H4zM4 0H28V2H4zM16 10a6 6 0 106 6A6 6 0 0016 10zm-4 6a4 4 0 014-4v8A4 4 0 0112 16z"
  })), children);
});
var WatsonHealthWindowBase32 = /*#__PURE__*/React.forwardRef(function WatsonHealthWindowBase32(_ref205, ref) {
  var children = _ref205.children,
      rest = _objectWithoutProperties(_ref205, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V5H15zM25 13H28V15H25zM15 23H17V26H15zM4 13H7V15H4z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55 5.03H9.55V8.030000000000001H7.55z",
    transform: "rotate(-45 8.56 6.544)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M21.96 5.54H24.96V7.54H21.96z",
    transform: "rotate(-45 23.469 6.539)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M22.46 19.94H24.46V22.94H22.46z",
    transform: "rotate(-45 23.462 21.442)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04 20.45H10.04V22.45H7.04z",
    transform: "rotate(-45 8.554 21.447)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M4 28H28V30H4zM16 20a6 6 0 10-6-6A6 6 0 0016 20zm0-10v8a4 4 0 010-8z"
  })), children);
});
var WatsonHealthWindowBase24 = /*#__PURE__*/React.forwardRef(function WatsonHealthWindowBase24(_ref206, ref) {
  var children = _ref206.children,
      rest = _objectWithoutProperties(_ref206, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V5H15zM25 13H28V15H25zM15 23H17V26H15zM4 13H7V15H4z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55 5.03H9.55V8.030000000000001H7.55z",
    transform: "rotate(-45 8.56 6.544)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M21.96 5.54H24.96V7.54H21.96z",
    transform: "rotate(-45 23.469 6.539)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M22.46 19.94H24.46V22.94H22.46z",
    transform: "rotate(-45 23.462 21.442)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04 20.45H10.04V22.45H7.04z",
    transform: "rotate(-45 8.554 21.447)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M4 28H28V30H4zM16 20a6 6 0 10-6-6A6 6 0 0016 20zm0-10v8a4 4 0 010-8z"
  })), children);
});
var WatsonHealthWindowBase20 = /*#__PURE__*/React.forwardRef(function WatsonHealthWindowBase20(_ref207, ref) {
  var children = _ref207.children,
      rest = _objectWithoutProperties(_ref207, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V5H15zM25 13H28V15H25zM15 23H17V26H15zM4 13H7V15H4z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55 5.03H9.55V8.030000000000001H7.55z",
    transform: "rotate(-45 8.56 6.544)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M21.96 5.54H24.96V7.54H21.96z",
    transform: "rotate(-45 23.469 6.539)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M22.46 19.94H24.46V22.94H22.46z",
    transform: "rotate(-45 23.462 21.442)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04 20.45H10.04V22.45H7.04z",
    transform: "rotate(-45 8.554 21.447)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M4 28H28V30H4zM16 20a6 6 0 10-6-6A6 6 0 0016 20zm0-10v8a4 4 0 010-8z"
  })), children);
});
var WatsonHealthWindowBase16 = /*#__PURE__*/React.forwardRef(function WatsonHealthWindowBase16(_ref208, ref) {
  var children = _ref208.children,
      rest = _objectWithoutProperties(_ref208, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V5H15zM25 13H28V15H25zM15 23H17V26H15zM4 13H7V15H4z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55 5.03H9.55V8.030000000000001H7.55z",
    transform: "rotate(-45 8.56 6.544)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M21.96 5.54H24.96V7.54H21.96z",
    transform: "rotate(-45 23.469 6.539)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M22.46 19.94H24.46V22.94H22.46z",
    transform: "rotate(-45 23.462 21.442)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04 20.45H10.04V22.45H7.04z",
    transform: "rotate(-45 8.554 21.447)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M4 28H28V30H4zM16 20a6 6 0 10-6-6A6 6 0 0016 20zm0-10v8a4 4 0 010-8z"
  })), children);
});
var WatsonHealthWindowOverlay32 = /*#__PURE__*/React.forwardRef(function WatsonHealthWindowOverlay32(_ref209, ref) {
  var children = _ref209.children,
      rest = _objectWithoutProperties(_ref209, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H17V9H15zM25 17H28V19H25zM15 27H17V30H15zM4 17H7V19H4z"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55 9.03H9.55V12.03H7.55z",
    transform: "rotate(-45 8.558 10.545)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M21.96 9.54H24.96V11.54H21.96z",
    transform: "rotate(-45 23.466 10.54)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M22.46 23.94H24.46V26.94H22.46z",
    transform: "rotate(-45 23.459 25.443)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04 24.45H10.04V26.45H7.04z",
    transform: "rotate(-45 8.55 25.448)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2H28V4H4zM16 24a6 6 0 10-6-6A6 6 0 0016 24zm0-10v8a4 4 0 010-8z"
  })), children);
});
var WatsonHealthWindowOverlay24 = /*#__PURE__*/React.forwardRef(function WatsonHealthWindowOverlay24(_ref210, ref) {
  var children = _ref210.children,
      rest = _objectWithoutProperties(_ref210, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H17V9H15zM25 17H28V19H25zM15 27H17V30H15zM4 17H7V19H4z"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55 9.03H9.55V12.03H7.55z",
    transform: "rotate(-45 8.558 10.545)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M21.96 9.54H24.96V11.54H21.96z",
    transform: "rotate(-45 23.466 10.54)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M22.46 23.94H24.46V26.94H22.46z",
    transform: "rotate(-45 23.459 25.443)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04 24.45H10.04V26.45H7.04z",
    transform: "rotate(-45 8.55 25.448)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2H28V4H4zM16 24a6 6 0 10-6-6A6 6 0 0016 24zm0-10v8a4 4 0 010-8z"
  })), children);
});
var WatsonHealthWindowOverlay20 = /*#__PURE__*/React.forwardRef(function WatsonHealthWindowOverlay20(_ref211, ref) {
  var children = _ref211.children,
      rest = _objectWithoutProperties(_ref211, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H17V9H15zM25 17H28V19H25zM15 27H17V30H15zM4 17H7V19H4z"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55 9.03H9.55V12.03H7.55z",
    transform: "rotate(-45 8.558 10.545)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M21.96 9.54H24.96V11.54H21.96z",
    transform: "rotate(-45 23.466 10.54)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M22.46 23.94H24.46V26.94H22.46z",
    transform: "rotate(-45 23.459 25.443)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04 24.45H10.04V26.45H7.04z",
    transform: "rotate(-45 8.55 25.448)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2H28V4H4zM16 24a6 6 0 10-6-6A6 6 0 0016 24zm0-10v8a4 4 0 010-8z"
  })), children);
});
var WatsonHealthWindowOverlay16 = /*#__PURE__*/React.forwardRef(function WatsonHealthWindowOverlay16(_ref212, ref) {
  var children = _ref212.children,
      rest = _objectWithoutProperties(_ref212, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H17V9H15zM25 17H28V19H25zM15 27H17V30H15zM4 17H7V19H4z"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55 9.03H9.55V12.03H7.55z",
    transform: "rotate(-45 8.558 10.545)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M21.96 9.54H24.96V11.54H21.96z",
    transform: "rotate(-45 23.466 10.54)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M22.46 23.94H24.46V26.94H22.46z",
    transform: "rotate(-45 23.459 25.443)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04 24.45H10.04V26.45H7.04z",
    transform: "rotate(-45 8.55 25.448)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2H28V4H4zM16 24a6 6 0 10-6-6A6 6 0 0016 24zm0-10v8a4 4 0 010-8z"
  })), children);
});
var WatsonHealthWindowPreset32 = /*#__PURE__*/React.forwardRef(function WatsonHealthWindowPreset32(_ref213, ref) {
  var children = _ref213.children,
      rest = _objectWithoutProperties(_ref213, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H17V8H15zM24 15H26V17H24zM15 24H17V26H15zM6 15H8V17H6z"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M8.586 8.586H10.586V10.586H8.586z",
    transform: "rotate(-45 9.586 9.586)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M21.414 8.586H23.414V10.586H21.414z",
    transform: "rotate(-45 22.414 9.586)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M21.414 21.414H23.414V23.414H21.414z",
    transform: "rotate(-45 22.414 22.414)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M8.586 21.414H10.586V23.414H8.586z",
    transform: "rotate(-45 9.586 22.414)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,0-6-6A6,6,0,0,0,16,22Zm0-10v8a4,4,0,0,1,0-8Z"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), children);
});
var WatsonHealthWindowPreset24 = /*#__PURE__*/React.forwardRef(function WatsonHealthWindowPreset24(_ref214, ref) {
  var children = _ref214.children,
      rest = _objectWithoutProperties(_ref214, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H17V8H15zM24 15H26V17H24zM15 24H17V26H15zM6 15H8V17H6z"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M8.586 8.586H10.586V10.586H8.586z",
    transform: "rotate(-45 9.586 9.586)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M21.414 8.586H23.414V10.586H21.414z",
    transform: "rotate(-45 22.414 9.586)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M21.414 21.414H23.414V23.414H21.414z",
    transform: "rotate(-45 22.414 22.414)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M8.586 21.414H10.586V23.414H8.586z",
    transform: "rotate(-45 9.586 22.414)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,0-6-6A6,6,0,0,0,16,22Zm0-10v8a4,4,0,0,1,0-8Z"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), children);
});
var WatsonHealthWindowPreset20 = /*#__PURE__*/React.forwardRef(function WatsonHealthWindowPreset20(_ref215, ref) {
  var children = _ref215.children,
      rest = _objectWithoutProperties(_ref215, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H17V8H15zM24 15H26V17H24zM15 24H17V26H15zM6 15H8V17H6z"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M8.586 8.586H10.586V10.586H8.586z",
    transform: "rotate(-45 9.586 9.586)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M21.414 8.586H23.414V10.586H21.414z",
    transform: "rotate(-45 22.414 9.586)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M21.414 21.414H23.414V23.414H21.414z",
    transform: "rotate(-45 22.414 22.414)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M8.586 21.414H10.586V23.414H8.586z",
    transform: "rotate(-45 9.586 22.414)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,0-6-6A6,6,0,0,0,16,22Zm0-10v8a4,4,0,0,1,0-8Z"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), children);
});
var WatsonHealthWindowPreset16 = /*#__PURE__*/React.forwardRef(function WatsonHealthWindowPreset16(_ref216, ref) {
  var children = _ref216.children,
      rest = _objectWithoutProperties(_ref216, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H17V8H15zM24 15H26V17H24zM15 24H17V26H15zM6 15H8V17H6z"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M8.586 8.586H10.586V10.586H8.586z",
    transform: "rotate(-45 9.586 9.586)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M21.414 8.586H23.414V10.586H21.414z",
    transform: "rotate(-45 22.414 9.586)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M21.414 21.414H23.414V23.414H21.414z",
    transform: "rotate(-45 22.414 22.414)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M8.586 21.414H10.586V23.414H8.586z",
    transform: "rotate(-45 9.586 22.414)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,0-6-6A6,6,0,0,0,16,22Zm0-10v8a4,4,0,0,1,0-8Z"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), children);
});
var Windy32 = /*#__PURE__*/React.forwardRef(function Windy32(_ref217, ref) {
  var children = _ref217.children,
      rest = _objectWithoutProperties(_ref217, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15H8V13H21a3 3 0 10-3-3H16a5 5 0 115 5zM23 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H4V18H23a5 5 0 010 10z"
  })), children);
});
var Windy24 = /*#__PURE__*/React.forwardRef(function Windy24(_ref218, ref) {
  var children = _ref218.children,
      rest = _objectWithoutProperties(_ref218, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15H8V13H21a3 3 0 10-3-3H16a5 5 0 115 5zM23 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H4V18H23a5 5 0 010 10z"
  })), children);
});
var Windy20 = /*#__PURE__*/React.forwardRef(function Windy20(_ref219, ref) {
  var children = _ref219.children,
      rest = _objectWithoutProperties(_ref219, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15H8V13H21a3 3 0 10-3-3H16a5 5 0 115 5zM23 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H4V18H23a5 5 0 010 10z"
  })), children);
});
var Windy16 = /*#__PURE__*/React.forwardRef(function Windy16(_ref220, ref) {
  var children = _ref220.children,
      rest = _objectWithoutProperties(_ref220, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15H8V13H21a3 3 0 10-3-3H16a5 5 0 115 5zM23 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H4V18H23a5 5 0 010 10z"
  })), children);
});
var WindyDust32 = /*#__PURE__*/React.forwardRef(function WindyDust32(_ref221, ref) {
  var children = _ref221.children,
      rest = _objectWithoutProperties(_ref221, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M23 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H22V18h1a5 5 0 010 10zM16 18H20V20H16zM10 18H14V20H10zM4 18H8V20H4zM21 15H20V13h1a3 3 0 10-3-3H16a5 5 0 115 5zM14 13H18V15H14zM8 13H12V15H8z"
  })), children);
});
var WindyDust24 = /*#__PURE__*/React.forwardRef(function WindyDust24(_ref222, ref) {
  var children = _ref222.children,
      rest = _objectWithoutProperties(_ref222, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M23 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H22V18h1a5 5 0 010 10zM16 18H20V20H16zM10 18H14V20H10zM4 18H8V20H4zM21 15H20V13h1a3 3 0 10-3-3H16a5 5 0 115 5zM14 13H18V15H14zM8 13H12V15H8z"
  })), children);
});
var WindyDust20 = /*#__PURE__*/React.forwardRef(function WindyDust20(_ref223, ref) {
  var children = _ref223.children,
      rest = _objectWithoutProperties(_ref223, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M23 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H22V18h1a5 5 0 010 10zM16 18H20V20H16zM10 18H14V20H10zM4 18H8V20H4zM21 15H20V13h1a3 3 0 10-3-3H16a5 5 0 115 5zM14 13H18V15H14zM8 13H12V15H8z"
  })), children);
});
var WindyDust16 = /*#__PURE__*/React.forwardRef(function WindyDust16(_ref224, ref) {
  var children = _ref224.children,
      rest = _objectWithoutProperties(_ref224, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M23 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H22V18h1a5 5 0 010 10zM16 18H20V20H16zM10 18H14V20H10zM4 18H8V20H4zM21 15H20V13h1a3 3 0 10-3-3H16a5 5 0 115 5zM14 13H18V15H14zM8 13H12V15H8z"
  })), children);
});
var WindySnow32 = /*#__PURE__*/React.forwardRef(function WindySnow32(_ref225, ref) {
  var children = _ref225.children,
      rest = _objectWithoutProperties(_ref225, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M25 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H6V18H25a5 5 0 010 10zM23 15H10V13H23a3 3 0 10-3-3H18a5 5 0 115 5z"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M11 23H13V25H11zM13 25H15V27H13zM15 27H17V29H15zM15 23H17V25H15zM11 27H13V29H11zM6 4H8V6H6zM8 6H10V8H8zM10 8H12V10H10zM10 4H12V6H10zM6 8H8V10H6zM2 26H4V28H2zM4 28H6V30H4zM6 30H8V32H6zM6 26H8V28H6zM2 30H4V32H2z"
  })), children);
});
var WindySnow24 = /*#__PURE__*/React.forwardRef(function WindySnow24(_ref226, ref) {
  var children = _ref226.children,
      rest = _objectWithoutProperties(_ref226, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M25 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H6V18H25a5 5 0 010 10zM23 15H10V13H23a3 3 0 10-3-3H18a5 5 0 115 5z"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M11 23H13V25H11zM13 25H15V27H13zM15 27H17V29H15zM15 23H17V25H15zM11 27H13V29H11zM6 4H8V6H6zM8 6H10V8H8zM10 8H12V10H10zM10 4H12V6H10zM6 8H8V10H6zM2 26H4V28H2zM4 28H6V30H4zM6 30H8V32H6zM6 26H8V28H6zM2 30H4V32H2z"
  })), children);
});
var WindySnow20 = /*#__PURE__*/React.forwardRef(function WindySnow20(_ref227, ref) {
  var children = _ref227.children,
      rest = _objectWithoutProperties(_ref227, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M25 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H6V18H25a5 5 0 010 10zM23 15H10V13H23a3 3 0 10-3-3H18a5 5 0 115 5z"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M11 23H13V25H11zM13 25H15V27H13zM15 27H17V29H15zM15 23H17V25H15zM11 27H13V29H11zM6 4H8V6H6zM8 6H10V8H8zM10 8H12V10H10zM10 4H12V6H10zM6 8H8V10H6zM2 26H4V28H2zM4 28H6V30H4zM6 30H8V32H6zM6 26H8V28H6zM2 30H4V32H2z"
  })), children);
});
var WindySnow16 = /*#__PURE__*/React.forwardRef(function WindySnow16(_ref228, ref) {
  var children = _ref228.children,
      rest = _objectWithoutProperties(_ref228, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M25 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H6V18H25a5 5 0 010 10zM23 15H10V13H23a3 3 0 10-3-3H18a5 5 0 115 5z"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M11 23H13V25H11zM13 25H15V27H13zM15 27H17V29H15zM15 23H17V25H15zM11 27H13V29H11zM6 4H8V6H6zM8 6H10V8H8zM10 8H12V10H10zM10 4H12V6H10zM6 8H8V10H6zM2 26H4V28H2zM4 28H6V30H4zM6 30H8V32H6zM6 26H8V28H6zM2 30H4V32H2z"
  })), children);
});
var WindyStrong32 = /*#__PURE__*/React.forwardRef(function WindyStrong32(_ref229, ref) {
  var children = _ref229.children,
      rest = _objectWithoutProperties(_ref229, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M13,30a5.0057,5.0057,0,0,1-5-5h2a3,3,0,1,0,3-3H4V20h9a5,5,0,0,1,0,10Z"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H2V15H25a5 5 0 010 10zM21 12H6V10H21a3 3 0 10-3-3H16a5 5 0 115 5z"
  })), children);
});
var WindyStrong24 = /*#__PURE__*/React.forwardRef(function WindyStrong24(_ref230, ref) {
  var children = _ref230.children,
      rest = _objectWithoutProperties(_ref230, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M13,30a5.0057,5.0057,0,0,1-5-5h2a3,3,0,1,0,3-3H4V20h9a5,5,0,0,1,0,10Z"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H2V15H25a5 5 0 010 10zM21 12H6V10H21a3 3 0 10-3-3H16a5 5 0 115 5z"
  })), children);
});
var WindyStrong20 = /*#__PURE__*/React.forwardRef(function WindyStrong20(_ref231, ref) {
  var children = _ref231.children,
      rest = _objectWithoutProperties(_ref231, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M13,30a5.0057,5.0057,0,0,1-5-5h2a3,3,0,1,0,3-3H4V20h9a5,5,0,0,1,0,10Z"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H2V15H25a5 5 0 010 10zM21 12H6V10H21a3 3 0 10-3-3H16a5 5 0 115 5z"
  })), children);
});
var WindyStrong16 = /*#__PURE__*/React.forwardRef(function WindyStrong16(_ref232, ref) {
  var children = _ref232.children,
      rest = _objectWithoutProperties(_ref232, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M13,30a5.0057,5.0057,0,0,1-5-5h2a3,3,0,1,0,3-3H4V20h9a5,5,0,0,1,0,10Z"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H2V15H25a5 5 0 010 10zM21 12H6V10H21a3 3 0 10-3-3H16a5 5 0 115 5z"
  })), children);
});
var WinterWarning32 = /*#__PURE__*/React.forwardRef(function WinterWarning32(_ref233, ref) {
  var children = _ref233.children,
      rest = _objectWithoutProperties(_ref233, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M21.684 19.051L19.167 19.891 13 15.486 13 7.369 15.555 5.665 14.445 4.001 12 5.631 9.555 4.001 8.445 5.665 11 7.369 11 14.057 6 10.486 6 8 4 8 4 10.279 1.684 11.051 2.316 12.949 4.833 12.11 10.28 16.001 4.833 19.891 2.316 19.051 1.684 20.949 4 21.721 4 24 6 24 6 21.515 11 17.944 11 24.631 8.445 26.335 9.555 27.999 12 26.368 14.445 27.999 15.555 26.335 13 24.631 13 17.943 18 21.515 18 24 20 24 20 21.721 22.316 20.949 21.684 19.051z"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
  })), children);
});
var WinterWarning24 = /*#__PURE__*/React.forwardRef(function WinterWarning24(_ref234, ref) {
  var children = _ref234.children,
      rest = _objectWithoutProperties(_ref234, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M21.684 19.051L19.167 19.891 13 15.486 13 7.369 15.555 5.665 14.445 4.001 12 5.631 9.555 4.001 8.445 5.665 11 7.369 11 14.057 6 10.486 6 8 4 8 4 10.279 1.684 11.051 2.316 12.949 4.833 12.11 10.28 16.001 4.833 19.891 2.316 19.051 1.684 20.949 4 21.721 4 24 6 24 6 21.515 11 17.944 11 24.631 8.445 26.335 9.555 27.999 12 26.368 14.445 27.999 15.555 26.335 13 24.631 13 17.943 18 21.515 18 24 20 24 20 21.721 22.316 20.949 21.684 19.051z"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
  })), children);
});
var WinterWarning20 = /*#__PURE__*/React.forwardRef(function WinterWarning20(_ref235, ref) {
  var children = _ref235.children,
      rest = _objectWithoutProperties(_ref235, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M21.684 19.051L19.167 19.891 13 15.486 13 7.369 15.555 5.665 14.445 4.001 12 5.631 9.555 4.001 8.445 5.665 11 7.369 11 14.057 6 10.486 6 8 4 8 4 10.279 1.684 11.051 2.316 12.949 4.833 12.11 10.28 16.001 4.833 19.891 2.316 19.051 1.684 20.949 4 21.721 4 24 6 24 6 21.515 11 17.944 11 24.631 8.445 26.335 9.555 27.999 12 26.368 14.445 27.999 15.555 26.335 13 24.631 13 17.943 18 21.515 18 24 20 24 20 21.721 22.316 20.949 21.684 19.051z"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
  })), children);
});
var WinterWarning16 = /*#__PURE__*/React.forwardRef(function WinterWarning16(_ref236, ref) {
  var children = _ref236.children,
      rest = _objectWithoutProperties(_ref236, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M21.684 19.051L19.167 19.891 13 15.486 13 7.369 15.555 5.665 14.445 4.001 12 5.631 9.555 4.001 8.445 5.665 11 7.369 11 14.057 6 10.486 6 8 4 8 4 10.279 1.684 11.051 2.316 12.949 4.833 12.11 10.28 16.001 4.833 19.891 2.316 19.051 1.684 20.949 4 21.721 4 24 6 24 6 21.515 11 17.944 11 24.631 8.445 26.335 9.555 27.999 12 26.368 14.445 27.999 15.555 26.335 13 24.631 13 17.943 18 21.515 18 24 20 24 20 21.721 22.316 20.949 21.684 19.051z"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
  })), children);
});
var WintryMix32 = /*#__PURE__*/React.forwardRef(function WintryMix32(_ref237, ref) {
  var children = _ref237.children,
      rest = _objectWithoutProperties(_ref237, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26H17V28H15zM17 28H19V30H17zM19 30H21V32H19zM19 26H21V28H19zM15 30H17V32H15zM13 16H15V18H13zM15 18H17V20H15zM17 20H19V22H17zM17 16H19V18H17zM13 20H15V22H13zM10 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0110 30z"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.5321,6.5321,0,0,0,2,15.5V22l1,2,1-2V20.18a6.4891,6.4891,0,0,0,3.4294,1.7246L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418.977.977,0,0,0-.489-.0894V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20h-.542v.0083A.9955.9955,0,0,0,22,21v3l1,2,1-2V21.9746a6.4473,6.4473,0,0,0,2-.4761V26l1,2,1-2V20.18A6.4876,6.4876,0,0,0,24.8008,9.1362Z"
  })), children);
});
var WintryMix24 = /*#__PURE__*/React.forwardRef(function WintryMix24(_ref238, ref) {
  var children = _ref238.children,
      rest = _objectWithoutProperties(_ref238, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26H17V28H15zM17 28H19V30H17zM19 30H21V32H19zM19 26H21V28H19zM15 30H17V32H15zM13 16H15V18H13zM15 18H17V20H15zM17 20H19V22H17zM17 16H19V18H17zM13 20H15V22H13zM10 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0110 30z"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.5321,6.5321,0,0,0,2,15.5V22l1,2,1-2V20.18a6.4891,6.4891,0,0,0,3.4294,1.7246L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418.977.977,0,0,0-.489-.0894V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20h-.542v.0083A.9955.9955,0,0,0,22,21v3l1,2,1-2V21.9746a6.4473,6.4473,0,0,0,2-.4761V26l1,2,1-2V20.18A6.4876,6.4876,0,0,0,24.8008,9.1362Z"
  })), children);
});
var WintryMix20 = /*#__PURE__*/React.forwardRef(function WintryMix20(_ref239, ref) {
  var children = _ref239.children,
      rest = _objectWithoutProperties(_ref239, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26H17V28H15zM17 28H19V30H17zM19 30H21V32H19zM19 26H21V28H19zM15 30H17V32H15zM13 16H15V18H13zM15 18H17V20H15zM17 20H19V22H17zM17 16H19V18H17zM13 20H15V22H13zM10 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0110 30z"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.5321,6.5321,0,0,0,2,15.5V22l1,2,1-2V20.18a6.4891,6.4891,0,0,0,3.4294,1.7246L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418.977.977,0,0,0-.489-.0894V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20h-.542v.0083A.9955.9955,0,0,0,22,21v3l1,2,1-2V21.9746a6.4473,6.4473,0,0,0,2-.4761V26l1,2,1-2V20.18A6.4876,6.4876,0,0,0,24.8008,9.1362Z"
  })), children);
});
var WintryMix16 = /*#__PURE__*/React.forwardRef(function WintryMix16(_ref240, ref) {
  var children = _ref240.children,
      rest = _objectWithoutProperties(_ref240, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26H17V28H15zM17 28H19V30H17zM19 30H21V32H19zM19 26H21V28H19zM15 30H17V32H15zM13 16H15V18H13zM15 18H17V20H15zM17 20H19V22H17zM17 16H19V18H17zM13 20H15V22H13zM10 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0110 30z"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.5321,6.5321,0,0,0,2,15.5V22l1,2,1-2V20.18a6.4891,6.4891,0,0,0,3.4294,1.7246L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418.977.977,0,0,0-.489-.0894V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20h-.542v.0083A.9955.9955,0,0,0,22,21v3l1,2,1-2V21.9746a6.4473,6.4473,0,0,0,2-.4761V26l1,2,1-2V20.18A6.4876,6.4876,0,0,0,24.8008,9.1362Z"
  })), children);
});
var WirelessCheckout32 = /*#__PURE__*/React.forwardRef(function WirelessCheckout32(_ref241, ref) {
  var children = _ref241.children,
      rest = _objectWithoutProperties(_ref241, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28V26A10,10,0,0,0,28,16h2A12,12,0,0,1,18,28Z"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23V21a5,5,0,0,0,5-5h2A7,7,0,0,1,18,23Z"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11H21V7a3,3,0,0,0-3-3H12A3,3,0,0,0,9,7v4H3a1,1,0,0,0-1,1.15L3.88,24.3a2,2,0,0,0,2,1.7H15V24H5.86L4.17,13H27ZM11,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H11Z"
  })), children);
});
var WirelessCheckout24 = /*#__PURE__*/React.forwardRef(function WirelessCheckout24(_ref242, ref) {
  var children = _ref242.children,
      rest = _objectWithoutProperties(_ref242, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28V26A10,10,0,0,0,28,16h2A12,12,0,0,1,18,28Z"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23V21a5,5,0,0,0,5-5h2A7,7,0,0,1,18,23Z"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11H21V7a3,3,0,0,0-3-3H12A3,3,0,0,0,9,7v4H3a1,1,0,0,0-1,1.15L3.88,24.3a2,2,0,0,0,2,1.7H15V24H5.86L4.17,13H27ZM11,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H11Z"
  })), children);
});
var WirelessCheckout20 = /*#__PURE__*/React.forwardRef(function WirelessCheckout20(_ref243, ref) {
  var children = _ref243.children,
      rest = _objectWithoutProperties(_ref243, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28V26A10,10,0,0,0,28,16h2A12,12,0,0,1,18,28Z"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23V21a5,5,0,0,0,5-5h2A7,7,0,0,1,18,23Z"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11H21V7a3,3,0,0,0-3-3H12A3,3,0,0,0,9,7v4H3a1,1,0,0,0-1,1.15L3.88,24.3a2,2,0,0,0,2,1.7H15V24H5.86L4.17,13H27ZM11,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H11Z"
  })), children);
});
var WirelessCheckout16 = /*#__PURE__*/React.forwardRef(function WirelessCheckout16(_ref244, ref) {
  var children = _ref244.children,
      rest = _objectWithoutProperties(_ref244, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28V26A10,10,0,0,0,28,16h2A12,12,0,0,1,18,28Z"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23V21a5,5,0,0,0,5-5h2A7,7,0,0,1,18,23Z"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11H21V7a3,3,0,0,0-3-3H12A3,3,0,0,0,9,7v4H3a1,1,0,0,0-1,1.15L3.88,24.3a2,2,0,0,0,2,1.7H15V24H5.86L4.17,13H27ZM11,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H11Z"
  })), children);
});
var Wmv32 = /*#__PURE__*/React.forwardRef(function Wmv32(_ref245, ref) {
  var children = _ref245.children,
      rest = _objectWithoutProperties(_ref245, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M29 9L27 22 25 9 23 9 25.52 23 28.48 23 31 9 29 9zM19 9L17.48 14 17 15.98 16.54 14 15 9 13 9 13 23 15 23 15 15 14.84 13 15.42 15 17 19.63 18.58 15 19.16 13 19 15 19 23 21 23 21 9 19 9zM9.2 9L8.86 17 8.6 21.54 8.19 18 7.51 12.54 5.49 12.54 4.81 18 4.4 21.54 4.14 17 3.8 9 2 9 3 23 5.27 23 6.03 18.07 6.49 14 6.5 13.97 6.51 14 6.97 18.07 7.73 23 10 23 11 9 9.2 9z"
  })), children);
});
var Wmv24 = /*#__PURE__*/React.forwardRef(function Wmv24(_ref246, ref) {
  var children = _ref246.children,
      rest = _objectWithoutProperties(_ref246, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M29 9L27 22 25 9 23 9 25.52 23 28.48 23 31 9 29 9zM19 9L17.48 14 17 15.98 16.54 14 15 9 13 9 13 23 15 23 15 15 14.84 13 15.42 15 17 19.63 18.58 15 19.16 13 19 15 19 23 21 23 21 9 19 9zM9.2 9L8.86 17 8.6 21.54 8.19 18 7.51 12.54 5.49 12.54 4.81 18 4.4 21.54 4.14 17 3.8 9 2 9 3 23 5.27 23 6.03 18.07 6.49 14 6.5 13.97 6.51 14 6.97 18.07 7.73 23 10 23 11 9 9.2 9z"
  })), children);
});
var Wmv20 = /*#__PURE__*/React.forwardRef(function Wmv20(_ref247, ref) {
  var children = _ref247.children,
      rest = _objectWithoutProperties(_ref247, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M29 9L27 22 25 9 23 9 25.52 23 28.48 23 31 9 29 9zM19 9L17.48 14 17 15.98 16.54 14 15 9 13 9 13 23 15 23 15 15 14.84 13 15.42 15 17 19.63 18.58 15 19.16 13 19 15 19 23 21 23 21 9 19 9zM9.2 9L8.86 17 8.6 21.54 8.19 18 7.51 12.54 5.49 12.54 4.81 18 4.4 21.54 4.14 17 3.8 9 2 9 3 23 5.27 23 6.03 18.07 6.49 14 6.5 13.97 6.51 14 6.97 18.07 7.73 23 10 23 11 9 9.2 9z"
  })), children);
});
var Wmv16 = /*#__PURE__*/React.forwardRef(function Wmv16(_ref248, ref) {
  var children = _ref248.children,
      rest = _objectWithoutProperties(_ref248, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M29 9L27 22 25 9 23 9 25.52 23 28.48 23 31 9 29 9zM19 9L17.48 14 17 15.98 16.54 14 15 9 13 9 13 23 15 23 15 15 14.84 13 15.42 15 17 19.63 18.58 15 19.16 13 19 15 19 23 21 23 21 9 19 9zM9.2 9L8.86 17 8.6 21.54 8.19 18 7.51 12.54 5.49 12.54 4.81 18 4.4 21.54 4.14 17 3.8 9 2 9 3 23 5.27 23 6.03 18.07 6.49 14 6.5 13.97 6.51 14 6.97 18.07 7.73 23 10 23 11 9 9.2 9z"
  })), children);
});
var WordCloud32 = /*#__PURE__*/React.forwardRef(function WordCloud32(_ref249, ref) {
  var children = _ref249.children,
      rest = _objectWithoutProperties(_ref249, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16H22V18H10zM10 20H18V22H10z"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7h0a8.0233,8.0233,0,0,1,7.8649,6.4935l.2591,1.346,1.3488.244A5.5019,5.5019,0,0,1,24.5076,26H7.4954a5.5019,5.5019,0,0,1-.9695-10.9165l1.3488-.244.2591-1.346A8.0256,8.0256,0,0,1,16,7m0-2a10.0244,10.0244,0,0,0-9.83,8.1155A7.5019,7.5019,0,0,0,7.4911,28H24.5076a7.5019,7.5019,0,0,0,1.3213-14.8845A10.0229,10.0229,0,0,0,15.9883,5Z"
  })), children);
});
var WordCloud24 = /*#__PURE__*/React.forwardRef(function WordCloud24(_ref250, ref) {
  var children = _ref250.children,
      rest = _objectWithoutProperties(_ref250, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16H22V18H10zM10 20H18V22H10z"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7h0a8.0233,8.0233,0,0,1,7.8649,6.4935l.2591,1.346,1.3488.244A5.5019,5.5019,0,0,1,24.5076,26H7.4954a5.5019,5.5019,0,0,1-.9695-10.9165l1.3488-.244.2591-1.346A8.0256,8.0256,0,0,1,16,7m0-2a10.0244,10.0244,0,0,0-9.83,8.1155A7.5019,7.5019,0,0,0,7.4911,28H24.5076a7.5019,7.5019,0,0,0,1.3213-14.8845A10.0229,10.0229,0,0,0,15.9883,5Z"
  })), children);
});

export { ViewNext16, ViewNext20, ViewNext24, ViewNext32, VirtualColumn16, VirtualColumn20, VirtualColumn24, VirtualColumn32, VirtualColumnKey16, VirtualColumnKey20, VirtualColumnKey24, VirtualColumnKey32, VirtualMachine16, VirtualMachine20, VirtualMachine24, VirtualMachine32, VirtualPrivateCloud16, VirtualPrivateCloud20, VirtualPrivateCloud24, VirtualPrivateCloud32, VirtualPrivateCloudAlt16, VirtualPrivateCloudAlt20, VirtualPrivateCloudAlt24, VirtualPrivateCloudAlt32, VisualRecognition16, VisualRecognition20, VisualRecognition24, VisualRecognition32, VmdkDisk16, VmdkDisk20, VmdkDisk24, VmdkDisk32, VoiceActivate16, VoiceActivate20, VoiceActivate24, VoiceActivate32, Voicemail16, Voicemail20, Voicemail24, Voicemail32, VolumeDown16, VolumeDown20, VolumeDown24, VolumeDown32, VolumeDownAlt16, VolumeDownAlt20, VolumeDownAlt24, VolumeDownAlt32, VolumeDownFilled16, VolumeDownFilled20, VolumeDownFilled24, VolumeDownFilled32, VolumeDownFilledAlt16, VolumeDownFilledAlt20, VolumeDownFilledAlt24, VolumeDownFilledAlt32, VolumeMute16, VolumeMute20, VolumeMute24, VolumeMute32, VolumeMuteFilled16, VolumeMuteFilled20, VolumeMuteFilled24, VolumeMuteFilled32, VolumeUp16, VolumeUp20, VolumeUp24, VolumeUp32, VolumeUpAlt16, VolumeUpAlt20, VolumeUpAlt24, VolumeUpAlt32, VolumeUpFilled16, VolumeUpFilled20, VolumeUpFilled24, VolumeUpFilled32, VolumeUpFilledAlt16, VolumeUpFilledAlt20, VolumeUpFilledAlt24, VolumeUpFilledAlt32, Vpn16, Vpn20, Vpn24, Vpn32, Wallet16, Wallet20, Wallet24, Wallet32, Warning16, Warning20, Warning24, Warning32, WarningAlt16, WarningAlt20, WarningAlt24, WarningAlt32, WarningAltFilled16, WarningAltFilled20, WarningAltFilled24, WarningAltFilled32, WarningAltInverted16, WarningAltInverted20, WarningAltInverted24, WarningAltInverted32, WarningAltInvertedFilled16, WarningAltInvertedFilled20, WarningAltInvertedFilled24, WarningAltInvertedFilled32, WarningFilled16, WarningFilled20, WarningFilled24, WarningFilled32, WarningHex16, WarningHex20, WarningHex24, WarningHex32, WarningHexFilled16, WarningHexFilled20, WarningHexFilled24, WarningHexFilled32, WarningOther16, WarningOther20, WarningOther24, WarningOther32, WarningSquare16, WarningSquare20, WarningSquare24, WarningSquare32, WarningSquareFilled16, WarningSquareFilled20, WarningSquareFilled24, WarningSquareFilled32, Watch16, Watch20, Watch24, Watch32, Watson16, Watson20, Watson24, Watson32, WatsonHealthWindowAuto16, WatsonHealthWindowAuto20, WatsonHealthWindowAuto24, WatsonHealthWindowAuto32, WatsonHealthWindowBase16, WatsonHealthWindowBase20, WatsonHealthWindowBase24, WatsonHealthWindowBase32, WatsonHealthWindowOverlay16, WatsonHealthWindowOverlay20, WatsonHealthWindowOverlay24, WatsonHealthWindowOverlay32, WatsonHealthWindowPreset16, WatsonHealthWindowPreset20, WatsonHealthWindowPreset24, WatsonHealthWindowPreset32, WatsonMachineLearning16, WatsonMachineLearning20, WatsonMachineLearning24, WatsonMachineLearning32, WaveDirection16, WaveDirection20, WaveDirection24, WaveDirection32, WaveHeight16, WaveHeight20, WaveHeight24, WaveHeight32, WavePeriod16, WavePeriod20, WavePeriod24, WavePeriod32, WeatherFrontCold16, WeatherFrontCold20, WeatherFrontCold24, WeatherFrontCold32, WeatherFrontStationary16, WeatherFrontStationary20, WeatherFrontStationary24, WeatherFrontStationary32, WeatherFrontWarm16, WeatherFrontWarm20, WeatherFrontWarm24, WeatherFrontWarm32, WeatherStation16, WeatherStation20, WeatherStation24, WeatherStation32, Websheet16, Websheet20, Websheet24, Websheet32, Wheat16, Wheat20, Wheat24, Wheat32, Wifi16, Wifi20, Wifi24, Wifi32, WifiOff16, WifiOff20, WifiOff24, WifiOff32, Wikis16, Wikis20, Wikis24, Wikis32, WindGusts16, WindGusts20, WindGusts24, WindGusts32, WindStream16, WindStream20, WindStream24, WindStream32, Windy16, Windy20, Windy24, Windy32, WindyDust16, WindyDust20, WindyDust24, WindyDust32, WindySnow16, WindySnow20, WindySnow24, WindySnow32, WindyStrong16, WindyStrong20, WindyStrong24, WindyStrong32, WinterWarning16, WinterWarning20, WinterWarning24, WinterWarning32, WintryMix16, WintryMix20, WintryMix24, WintryMix32, WirelessCheckout16, WirelessCheckout20, WirelessCheckout24, WirelessCheckout32, Wmv16, Wmv20, Wmv24, Wmv32, WordCloud24, WordCloud32 };
